function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogoMotto = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 670 632",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-751.649,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bijelo",
    transform: "matrix(1,0,0,1,751.649,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 669.6,
    height: 631.92,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,0L352.8,0C359.58,0.29 364.7,4.17 369.8,8C373.72,10.9 377.51,14 381.48,16.8C383.81,18.46 386.48,20.17 388.99,20.28C395.12,20.55 400.99,23.14 407.44,21.14C414.421,18.811 421.572,17.029 428.83,15.81C437.77,14.5 444.83,17.81 450.64,24.22C455.82,29.9 459.81,36.52 464.64,42.46C465.918,44.103 467.539,45.447 469.39,46.4C471.861,47.534 474.265,48.809 476.59,50.22C481.21,53.22 486.47,53.14 491.64,53.38C496.81,53.62 502.01,53.38 507.21,53.84C516.7,54.72 523.55,59.11 527.76,67.77C530.76,73.83 532.76,80.23 535,86.55C536.107,90.156 538.138,93.41 540.89,95.99C541.013,96.093 541.127,96.207 541.23,96.33C546.69,103.56 554.43,106.86 562.89,109.05C567.921,110.367 572.803,112.196 577.46,114.51C584.03,117.76 587.87,123.03 589.46,130.05C590.463,134.824 591.005,139.683 591.08,144.56C591.2,147.84 591.53,151.09 591.74,154.35C591.894,157.401 592.827,160.362 594.45,162.95C595.95,165.31 597.32,167.76 598.65,170.22C600.3,173.22 602.95,175.33 605.74,177.22C610.29,180.34 614.99,183.22 619.42,186.53C621.828,188.252 624.061,190.205 626.09,192.36C631.6,198.43 632.17,205.68 631.18,213.29C630.428,218.108 629.4,222.88 628.1,227.58C624.847,240.061 628.253,253.375 637.1,262.76C638.92,264.76 640.61,266.92 642.34,269.01C643.337,270.249 644.766,271.067 646.34,271.3C650.76,272.05 655.13,273.02 659.53,273.89C660.57,274.039 661.582,274.346 662.53,274.8C663.75,275.44 664.81,276.17 666.43,275.51C667.624,275.154 668.911,275.737 669.43,276.87L669.43,278.79C665.77,307.18 659.06,334.99 653.76,363.07C647.1,398.33 640.1,433.53 633.16,468.74C632.63,471.4 632.11,474.07 631.68,476.74C631.535,478.208 630.506,479.447 629.09,479.86C628.18,480.17 627.28,480.49 626.37,480.79C610.66,486 594.98,491.32 579.24,496.43C576.47,497.33 575.04,498.78 574.46,501.63C573.29,507.35 572.65,513.16 571.46,518.87C571.053,520.83 570.593,522.773 570.08,524.7C567.86,533.1 562.63,538.61 554.4,541.4C548.23,543.49 541.82,544.49 535.49,545.79C530.543,546.798 525.892,548.922 521.89,552C516.768,555.712 512.676,560.668 510,566.4C507.91,570.95 505.74,575.49 503.38,579.92C498.38,589.37 490.68,594.13 479.89,593.97C473.56,593.88 467.3,593.15 461.01,592.68C457.29,592.4 453.69,592.3 450.26,594.13C448.557,595.025 446.764,595.735 444.91,596.25C439.99,597.64 436.45,600.85 433.15,604.56C428.86,609.4 424.77,614.4 419.88,618.7C413.44,624.37 406.15,625.88 397.99,623.97C391.871,622.374 385.901,620.25 380.15,617.62C374.49,615.2 368.8,615.27 362.8,615.54C356.17,615.83 350.8,618.54 345.55,621.93C344.714,622.551 343.751,622.981 342.73,623.19C342.106,623.208 341.496,623.002 341.01,622.61C339.88,621.91 339.4,623.23 338.55,623.45C338.15,623.56 339.07,623.92 339.11,624.38C339.175,624.76 339.137,625.15 339,625.51C334.7,628.95 330,631.31 324.36,631.68C323.9,631.68 323.36,631.55 323,631.92L318.7,631.92C312.26,631.83 307.23,628.46 302.35,624.8C298.51,621.93 294.73,618.96 290.89,616.09C288.148,613.857 284.837,612.434 281.33,611.98C278.86,611.728 276.419,611.242 274.04,610.53C271.007,609.754 267.822,609.795 264.81,610.65C259.35,611.9 254.02,613.65 248.58,614.94C245.248,615.81 241.831,616.32 238.39,616.46C232.724,616.554 227.25,614.374 223.2,610.41C218.27,605.87 214.39,600.48 210.67,594.99C207.134,589.855 202.369,585.684 196.81,582.86C191.524,580.019 185.611,578.54 179.61,578.56C174.26,578.5 168.92,578.66 163.56,578.11C154.29,577.11 147.51,572.87 143.31,564.42C140.31,558.3 138.37,551.77 135.95,545.42C134.441,541.569 132.204,538.044 129.36,535.04C124.217,529.324 117.469,525.287 110,523.46C104.326,522.06 98.82,520.048 93.58,517.46C87.799,514.679 83.532,509.482 81.93,503.27C80.44,497.9 80.17,492.39 79.88,486.89C79.71,483.7 79.42,480.52 79.23,477.33C79.068,474.523 78.223,471.797 76.77,469.39C75.12,466.66 73.44,463.93 71.98,461.08C71.258,459.736 70.26,458.56 69.05,457.63C65.877,455.052 62.536,452.687 59.05,450.55C54.738,447.939 50.665,444.95 46.88,441.62C40.08,435.62 38.52,427.92 39.68,419.36C40.44,413.72 42.02,408.26 43.23,402.71C43.69,400.6 43.96,398.46 44.35,396.34C44.686,394.752 44.024,393.11 42.68,392.2C29.56,381.1 16.58,369.83 3.41,358.77C1.128,357.124 0.126,354.2 0.92,351.5C3.21,340.38 5.31,329.22 7.49,318.08C15.83,275.473 24.163,232.863 32.49,190.25C34.65,179.25 36.75,168.25 38.92,157.3C39.7,153.3 40.34,152.93 44.31,153.71C50.9,155 57.52,156.17 64.09,157.58C65.728,158.023 67.476,157.8 68.95,156.96C73,154.53 77.34,152.65 81.43,150.29C84.54,148.49 86.78,145.93 89.16,143.29C95.5,136.19 97.48,127.67 98.51,118.65C99.037,113.954 100.086,109.332 101.64,104.87C103.537,98.913 107.973,94.089 113.75,91.7C117.292,90.205 120.978,89.075 124.75,88.33C129.75,87.33 134.8,86.41 139.75,85.11C142.487,84.488 145.034,83.211 147.17,81.39C148.094,80.506 149.099,79.709 150.17,79.01C156.03,75.47 159.17,69.93 161.85,63.91C163.926,59.056 166.335,54.352 169.06,49.83C174.06,41.69 181.37,37.9 190.91,37.97C197.33,37.97 203.67,38.8 210.04,39.28C213.77,39.56 217.38,39.59 220.82,37.85C222.532,36.976 224.324,36.266 226.17,35.73C231,34.34 234.58,31.25 237.73,27.54C241.62,22.96 245.73,18.66 250.01,14.4C256.6,7.76 264.4,5.93 273.35,8.05C280.01,9.63 286.2,12.49 292.55,14.9C297.398,16.841 302.707,17.334 307.83,16.32C308.368,16.154 308.927,16.07 309.49,16.07C314.69,16.5 318.89,13.99 323.11,11.49C325.24,10.22 327.33,8.89 329.44,7.58C335.19,4 340.86,0.22 348,0ZM115.64,475C115.94,477.12 117.28,478.67 118.52,480.26C120.58,482.89 122.61,485.54 124.72,488.12C125.37,488.9 125.72,490.12 127.16,490.04C127.68,490.04 128.16,490.94 128.23,491.53C128.576,492.752 129.271,493.847 130.23,494.68C169.717,539.6 218.64,568.667 277,581.88C285.42,583.78 293.94,585.17 302.51,586.24C303.596,586.508 304.735,586.47 305.8,586.13C307.01,585.61 308.26,586.23 309.33,586.63C311.95,587.63 314.68,587.45 317.33,587.63C329.538,588.5 341.792,588.5 354,587.63C376.678,586.135 399.069,581.725 420.62,574.51C479.907,554.463 527.127,518.54 562.28,466.74C563.15,465.44 563.9,464.94 565.53,465.31C570.36,466.39 575.23,467.25 580.24,468.23C579.963,469.157 579.511,470.022 578.91,470.78C537.025,536.154 470.621,582.071 394.67,598.18C370.299,603.364 345.351,605.321 320.47,604C304.572,603.186 288.771,601.022 273.24,597.53C272.103,597.188 270.902,597.109 269.73,597.3C269.12,597.44 268.33,597.68 267.93,596.68C267.62,595.92 266.7,596.05 266.02,595.88C229.554,586.947 195.222,570.862 165.02,548.56C151.482,538.601 138.835,527.486 127.22,515.34C126.53,514.62 126.04,513.58 124.87,513.42C124.47,513.42 124.38,513.13 124.38,512.77C124.38,512.03 123.78,511.67 123.38,511.22C106.173,492.454 91.492,471.52 79.71,448.95L79.29,448.22C78.78,447.89 78.65,448.29 78.45,448.48C78.28,448.647 78.119,448.824 77.97,449.01C77.59,448.74 77.3,448.26 77.57,448.01C78.77,446.8 78.14,445.73 77.5,444.59C77.03,443.76 76.68,442.86 76.27,442C75.87,441.58 75.18,441.32 75.43,440.53C74.97,438.92 74.18,437.64 72.21,437.67C72.49,436.76 73.21,437.32 73.73,436.82C63.223,414.123 55.713,390.155 51.39,365.52C51.9,365.01 52.39,365.23 52.84,365.32C57.3,366.193 61.763,367.077 66.23,367.97C68.23,368.37 68.23,368.37 68.64,370.25C71.651,384.879 75.845,399.24 81.18,413.19C81.576,414.411 82.186,415.552 82.98,416.56C83.21,416.83 83.74,417.07 83.56,417.56C82.84,419.36 84.27,419.2 85.81,419.43C84.44,420.11 84.15,420.74 84.64,421.87C88.807,431.644 93.535,441.17 98.8,450.4C101.95,455.87 105.14,461.33 108.72,466.53C109.33,467.42 109.66,468.61 110.91,468.95C111.28,469.05 111.33,469.37 111.3,469.71C111.18,470.92 112.3,471.42 112.73,472.42C113.22,471.71 112.16,470.8 113.49,470.42L114.33,472.6C114.11,473.72 115,474.33 115.64,475ZM305.3,579.624L305.32,579.7L305.26,579.64L305.3,579.624C304.895,578.101 303.825,577.527 302.32,577.34C265.725,572.733 230.508,560.466 198.97,541.34C198.17,540.86 197.42,539.84 196.24,540.72C196,540.91 195.44,540.67 195.52,540.36C195.92,538.78 194.52,538.6 193.73,538.08C166.209,520.425 142.197,497.823 122.91,471.42C122.34,470.64 121.99,469.42 120.57,469.85C119.8,470.7 120.69,471.42 120.75,472.2C120.84,473.33 120.75,474.37 119.16,473.52C118.574,472.433 118.515,471.136 119,470C119.82,468.44 118.45,468.51 118,467.9C117.32,467.17 118.66,466.09 117.58,465.43C117.38,464.99 117.25,464.43 116.58,464.5C116.106,464.446 115.645,464.307 115.22,464.09C114.74,463.68 113.59,463.79 113.83,462.81C114.07,461.83 114.78,461.23 116.08,462.49L116.13,461.84L113.72,458.18C112.61,457.79 112.42,456.83 112.28,455.84C105.515,445.111 99.565,433.89 94.48,422.27C94.18,421.62 93.42,421.2 93.57,420.32C86.693,404.325 81.394,387.696 77.75,370.67C78.42,370.03 79.15,370.43 79.75,370.55C90.57,372.65 101.39,374.76 112.21,376.88C112.92,377.02 113.87,377.79 114.3,376.33C114.44,375.88 114.94,376.33 115.24,376.55C116.588,377.543 118.162,378.186 119.82,378.42C139.82,382.293 159.82,386.187 179.82,390.1L242.62,402.37L302.62,414.08L365.62,426.4L433.14,439.55L466.12,446L528.64,458.22C536.72,459.787 544.797,461.367 552.87,462.96C553.17,463.02 553.47,463.11 554.13,463.27C526.21,503.89 490.19,534.65 445.61,555.27C401.03,575.89 354.34,583.17 305.61,577.84C305.373,578.422 306.276,579.219 305.3,579.624ZM585.253,275.525C585.203,275.51 585.148,275.498 585.09,275.49L585.27,275.46L585.253,275.525C585.916,275.715 585.895,276.399 586.09,276.91C586.19,277.218 586.479,277.428 586.803,277.428C586.884,277.428 586.964,277.415 587.04,277.39C587.7,277.25 587.26,276.82 587.24,276.48C587.049,275.697 586.76,274.941 586.38,274.23C586.14,273.43 586.43,273.43 586.81,273.03C587.36,272.45 587.81,272.56 588.21,273.03C588.82,273.717 589.645,274.179 590.55,274.34C590.91,274.66 590.86,274.76 590.74,274.93C590.3,275.52 588.95,275.33 589.21,276.42C589.596,277.648 590.442,278.68 591.57,279.3C592.199,279.662 592.934,279.797 593.65,279.68C595.21,279.13 596.88,277.79 598.04,280.27C599.63,281.38 601.56,281.22 603.32,281.68C603.6,281.43 603.76,280.92 604.32,281.22C604.7,282.13 605.56,282.08 606.32,282.22L637.82,288.43L647.22,290.28C649.22,290.68 649.3,290.68 648.91,292.7C647.577,299.6 646.243,306.5 644.91,313.4C641.163,332.513 637.413,351.63 633.66,370.75C629.22,393.47 624.787,416.193 620.36,438.92C619.36,444.17 618.36,449.43 617.25,454.67C616.61,457.72 617.25,457.55 614.03,456.92C600.79,454.32 587.54,451.78 574.29,449.2C547.783,444.04 521.28,438.877 494.78,433.71C468.82,428.65 442.867,423.573 416.92,418.48C416.68,418.43 416.44,418.41 416.21,418.37C415.59,417.94 414.8,418.48 414.21,418.01C402.71,415.737 391.203,413.473 379.69,411.22L319.55,399.48L261.76,388.19L256.83,387.19C256.24,386.73 255.41,387.44 254.83,386.79L223.54,380.71L165.9,369.47L101,356.78L50.43,346.9C41.49,345.153 32.56,343.393 23.64,341.62C21.88,341.28 21.83,341.24 22.19,339.41C23.99,330.077 25.807,320.743 27.64,311.41C31.38,292.29 35.127,273.173 38.88,254.06C43.64,229.773 48.393,205.48 53.14,181.18C53.48,179.46 53.93,177.75 54.14,176.01C54.29,174.64 54.89,174.5 56.05,174.74C60.98,175.74 65.91,176.74 70.85,177.66L116.95,186.66C137.89,190.753 158.827,194.843 179.76,198.93C198.967,202.69 218.18,206.44 237.4,210.18L302.33,222.85L362.78,234.66L427.71,247.33L485.58,258.63C493.273,260.13 500.96,261.62 508.64,263.1C509.39,263.25 510.31,264.03 510.84,262.7C510.99,262.3 511.32,262.65 511.34,262.77C511.58,264.09 512.7,263.9 513.57,264.07C528.57,267.02 543.57,269.92 558.48,272.97C559.77,273.23 561.01,272.27 562.48,273.46C563.55,274.36 565.48,274.21 567.08,274.52L571.54,275.42L576.01,276.31L580.71,277.23C582.2,277.51 583.71,277.81 585.19,278.07C585.85,278.193 586.524,278.214 587.19,278.13C586.81,277.7 585.97,278 585.79,277.2C585.664,276.637 585.086,276.225 585.253,275.525ZM574.1,184.72C569.09,175.708 563.588,166.978 557.62,158.57C557,157.72 556.71,156.44 555.36,156.29C554.98,156.29 555.06,155.99 555.11,155.79C555.36,154.79 554.57,154.33 554.11,153.73C514.657,101.443 463.16,67.31 399.62,51.33C394.73,50.11 389.8,49.12 384.86,48.17C384.336,47.991 383.776,47.947 383.23,48.04C382.42,48.36 381.77,48.9 381.35,47.6C381.29,47.43 380.6,47.47 380.21,47.4C373.36,46.16 366.46,45.33 359.53,44.71C349.414,43.792 339.254,43.458 329.1,43.71C240.528,46.01 158.376,91.191 109,164.76C108.69,165.22 108.36,165.68 108.08,166.16C107.827,166.676 107.231,166.936 106.68,166.77C101.44,165.71 96.19,164.69 90.85,163.64C91.18,162.624 91.696,161.678 92.37,160.85C122.31,114.51 162.157,79.407 211.91,55.54C212.403,55.272 212.91,55.031 213.43,54.82C214.014,54.7 214.437,54.182 214.437,53.586C214.437,53.458 214.418,53.332 214.38,53.21C214.061,51.772 214.562,50.269 215.68,49.31C216.25,49.88 216.12,50.62 216.17,51.31C216.22,52 216.17,52.46 217.03,52.39C217.801,52.015 218.517,51.537 219.16,50.97C219.417,50.648 219.737,50.383 220.1,50.19C220.286,50.135 220.484,50.135 220.67,50.19C221.02,50.34 221.32,50.58 221.67,50.72C221.838,50.792 222.012,50.848 222.19,50.89C239.454,43.512 257.391,37.819 275.75,33.89C281.69,32.63 287.66,31.57 293.66,30.66C328.178,25.564 363.338,26.808 397.41,34.33C397.87,34.43 398.35,34.45 398.82,34.51C400.22,33.94 401.22,34.75 402.24,35.51C416.152,38.737 429.79,43.047 443.03,48.4C467.439,58.172 490.38,71.273 511.2,87.33C512.04,87.75 513.2,87.66 513.65,88.71C513.87,88.8 514.19,88.83 514.29,89C515.75,91.57 518.29,92.93 520.48,94.75C531.058,103.674 541.006,113.32 550.25,123.62C550.783,124.42 551.527,125.057 552.4,125.46C552.74,125.57 553.25,125.95 553.25,126.21C553.25,127.7 554.46,128.39 555.25,129.32C563.051,138.534 570.278,148.219 576.89,158.32C597.638,190.019 611.963,225.484 619.05,262.7C619.26,263.8 619.44,264.91 619.63,266.01C619.645,266.166 619.645,266.324 619.63,266.48C619.16,267.04 618.63,266.73 618.08,266.63C613.61,265.76 609.15,264.78 604.66,264.03C603.456,263.976 602.475,263.013 602.4,261.81C599.127,245.505 594.305,229.549 588,214.16C585.5,208.05 582.92,201.97 579.93,196.07C579.5,194.931 578.816,193.905 577.93,193.07C577.463,192.67 577.193,192.085 577.19,191.47C577.111,189.713 576.141,188.113 574.62,187.23C573.76,187.23 573.69,186.77 573.99,186.12C574.75,185.69 574.28,185.2 574.1,184.72ZM437.22,231.33L402.65,224.53L340.08,212.31L279.86,200.55L219.86,188.86L159.42,177L118,168.93C117.77,168.93 117.54,168.81 117.29,168.74C117.512,167.802 117.99,166.943 118.67,166.26C152.87,117.64 198.203,83.973 254.67,65.26C270.711,59.996 287.236,56.338 304,54.34C309.95,53.6 315.93,53.1 321.92,52.8L322.4,52.8C329.55,52.2 345.28,52.49 353.28,53.07C360.22,53.57 367.16,54.18 374.02,55.24C384.369,56.799 394.616,58.966 404.71,61.73C460.043,77.063 505.67,107.097 541.59,151.83C542.48,152.93 543.17,154.37 545.19,153.61C543.94,154.61 544.12,155.56 545.19,156.28C546.26,157 546.36,158.06 547,158.93C569.371,188.962 585.088,223.419 593.1,260C593.2,260.45 593.24,260.92 593.34,261.55C591.737,261.587 590.139,261.361 588.61,260.88C565.083,256.293 541.547,251.69 518,247.07L447.91,233.35C445.01,232.78 442.1,232.25 439.2,231.71C438.63,231.21 437.78,232 437.22,231.33Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M946.05,348.23C945.818,348.26 945.582,348.26 945.35,348.23C944.431,348.04 943.498,347.93 942.56,347.9C942.251,347.866 941.948,347.789 941.66,347.67C941.87,347.45 942.25,347.25 942.26,347.02C942.26,346.6 943.26,345.91 941.9,345.7C941.46,345.62 941.9,344.7 941.9,344.22C942.9,343.97 943.09,344.97 943.69,345.22C944.06,345.35 944.89,345.98 944.69,344.51C944.48,342.71 945.9,341.93 947.61,342.57C948.08,342.74 948.53,345.14 948.1,345.76C947.47,346.59 946.73,347.39 946.05,348.23Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.91,118.42L568.37,118.42C567.48,118.31 567.6,118.8 567.82,119.35C567.77,119.56 567.7,119.97 567.68,119.97C566.62,119.86 566.21,121.02 565.29,121.16C564.03,120.22 564.29,118.64 563.67,117.41C563.79,116.96 563.95,116.14 564.29,116.27C566.01,116.91 566.17,114.89 567.29,114.58C567.45,116.58 569.35,117.37 570.19,118.86C570.109,119.125 569.844,119.292 569.57,119.25C569.25,119.071 569.013,118.772 568.91,118.42Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.24,332.85C917.89,332.8 917.52,332.43 917.18,332.85C916.84,333.27 916.72,333.5 916.45,333.79C916.117,334.258 915.499,334.433 914.97,334.21C914.659,334.096 914.466,333.779 914.51,333.45C914.51,332.91 914.65,332.3 915.41,332.3C916.41,332.3 916.41,331.48 916.67,330.87C916.05,330.23 915.27,331.03 914.67,330.57C914.42,330.39 914.04,330.32 914.03,329.97C914.02,329.62 914.3,329.44 914.66,329.43C915.055,329.434 915.449,329.407 915.84,329.35C916.73,329.17 918.07,328.42 918.37,329.35C918.67,330.28 919.49,331.72 918.25,332.81L918.24,332.85Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.18,86L671,83.6C671.49,82.6 672.28,82.82 673.19,83.04C673.19,82.35 672.41,81.92 672.91,81.04C673.41,80.16 673.13,79.89 674.27,80.38C674.4,80.43 674.61,80.54 674.65,80.5C674.93,80.21 674.81,79.04 675.65,79.99C675.875,80.237 676.001,80.559 676.001,80.894C676.001,81.295 675.82,81.676 675.51,81.93C674.372,83.045 673.565,84.454 673.18,86Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.32,523.82C461.04,524.45 461.22,525.42 461.76,526.16C459.1,525.78 456.45,525.37 453.76,525.02C453.205,524.968 452.726,524.602 452.53,524.08C452.39,523.78 452.6,523.24 452.79,523.37C453.64,523.96 454.33,522.95 455.32,523.37C456.696,523.889 458.106,524.314 459.54,524.64C460,524.7 460.15,524.17 460.32,523.82Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.57,488.32C442.163,488.785 442.513,489.496 442.52,490.25C441.17,490.51 440.19,491.48 439.01,492.07C438.93,492.07 438.88,492.41 438.92,492.43C440.17,493.27 438.92,493.75 438.59,493.56C437.69,493.05 437.85,494.83 437.27,494.11C437.1,493.895 437.008,493.629 437.008,493.355C437.008,492.891 437.273,492.465 437.69,492.26C438.59,491.61 438.9,490.39 440,489.91C439.84,488.98 438.64,488.99 438.54,488.04C439.61,487.34 440.5,489.19 441.57,488.32Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M952.31,349.18C951.98,349.31 951.8,349.79 951.31,349.64C951.31,349.23 951.31,348.71 950.77,348.81C949.77,349.01 949.98,348.03 949.57,347.67C948.96,347.13 949.41,346.61 949.57,346.06C950.09,346.32 950.37,347.29 951.09,346.72C951.99,346.01 952.45,345.95 952.42,347.28C953.053,347.356 953.693,347.336 954.32,347.22C954.73,347.08 955.05,346.88 955.32,347.32C955.483,347.666 955.538,348.052 955.48,348.43C955.42,348.82 954.96,348.8 954.68,348.74C953.82,348.59 953,348.42 952.31,349.18Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690.29,690.92C689.39,692.08 687.9,692.29 686.78,693.11C686.55,691.97 685.35,691.43 685.02,690.26C685.87,689.77 685.94,690.95 686.52,690.92C688.18,688.36 688.31,688.36 690.29,690.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.12,332.33C909.63,332.42 908.73,331.73 908.84,333.13C908.84,333.62 908.34,333.29 907.99,333.13C907.26,332.81 907.99,330.99 906.4,331.66C906.4,331.45 906.25,331.15 906.34,331.03C906.71,330.54 907,329.85 907.78,330.03C908.236,330.145 908.674,330.323 909.08,330.56C909.49,330.77 909.87,331.18 910.32,330.68C910.77,330.18 911.26,330.4 911.61,330.92C911.83,331.23 912.18,331.52 911.9,331.92C911.61,332.311 911.118,332.502 910.64,332.41C910.48,332.4 910.33,332.36 910.12,332.33Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.81,454.77C603.5,454.547 604.259,454.699 604.81,455.17C604.58,455.29 604.14,455.35 604.48,455.76C605.97,457.55 605.62,459.26 604.29,460.94L604.34,460.94C604.08,459.83 604.81,458.76 604.43,457.64C604.28,457.19 604.25,456.73 603.57,456.73C602.89,456.73 602.49,456.85 602.44,457.59C602.486,458.268 602.185,458.924 601.64,459.33C601.321,458.264 601.502,457.109 602.13,456.19C602.34,455.74 602.9,455.41 602.81,454.77Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922,254.12C922.08,254.56 922.15,255.01 922.63,255.23C922.233,256.489 921.079,257.365 919.76,257.41C918.92,256.92 920.29,255.32 918.76,255.06C918.96,254.33 919.33,253.75 920.16,253.69C920.8,253.673 921.434,253.821 922,254.12Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.8,304.5C803.71,304.59 805.29,307.14 804.8,307.83C804.54,308.2 804.12,308.75 803.45,308.47C802.54,308.1 801.76,305.62 802.24,304.77C802.37,304.52 802.57,304.51 802.8,304.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.43,226.25C897.81,226.72 898.56,227.88 897.66,228.03C896.76,228.18 896.35,227.22 896.2,226.49C895.934,225.652 896.099,224.734 896.64,224.04C896.91,223.75 897.46,223.9 897.74,224.09C898.5,224.61 898,225.56 898.43,226.25Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.35,462.23C574.86,460.17 574.86,460.17 572.83,460.23C573.06,459.11 574.37,459.15 574.83,458.31C575.38,459.11 576.69,459.05 576.83,460.31C576.97,461.57 576.07,461.48 575.35,462.23Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M563.67,117.4L564.87,116.85C564.15,118.55 565.54,119.7 565.29,121.15C565.001,121.281 564.704,121.391 564.4,121.48C563.49,121.7 562.82,121.26 563.15,120.54C563.63,119.47 563.27,118.34 563.7,117.31L563.67,117.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.11,541.49C467.49,541.49 468.17,541.94 468.05,541.05C467.9,539.91 467.52,538.78 468.52,537.82C468.383,538.361 468.678,538.924 469.2,539.12C469.65,539.408 469.922,539.907 469.922,540.441C469.922,540.75 469.831,541.053 469.66,541.31C468.947,541.928 467.903,542.002 467.11,541.49Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.91,569.91C455.39,567.91 456.82,567.51 457.5,566.68C457.82,566.28 458.16,565.95 458.66,566.38C458.891,566.57 459.024,566.853 459.024,567.152C459.024,567.408 458.926,567.654 458.75,567.84C458.423,568.276 457.989,568.62 457.49,568.84C456.855,569.002 456.296,569.381 455.91,569.91Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.93,83.06C689.3,81.68 690.09,81.47 691.08,82.06C691.591,82.332 691.827,82.945 691.63,83.49C691.46,84.02 690.94,84.02 690.45,84.02C689.55,84 688.93,83.37 687.93,83.06Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.44,205.65C886.23,206.86 884.53,207.39 885.14,209.05C884.41,208.05 884.62,206.53 882.74,206.84C883.44,205.77 884.43,205.43 885.13,204.76L885.38,204.84L885.91,205.03C886.178,205.136 886.377,205.368 886.44,205.65Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.59,75.86C702.818,76.433 702.94,77.043 702.95,77.66C703.11,78.44 702.81,78.75 702.09,78.97C701.19,79.25 700.86,78.51 700.34,78.12C700.24,78.05 700.34,77.51 700.34,77.49C701.35,77.28 701.47,75.94 702.59,75.86Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789,110.36C790.16,109.57 791.24,108.02 792.65,109.99C790.32,111.76 790.32,111.76 789,110.36Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447,566.65C447.435,566.474 447.93,566.514 448.33,566.76C448.95,567.05 449.52,567.21 449.65,566.19C449.71,565.71 450.11,565.54 450.51,565.9C450.91,566.26 451.14,566.68 450.73,567.12C450.123,567.754 449.267,568.091 448.39,568.04C447.52,568 447.16,567.5 447,566.65Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.27,103.47C749.15,103.06 747.82,103.4 746.85,102.47C746.69,102.09 746.49,101.61 747.01,101.47C748.64,100.98 749.46,101.47 750.01,103.09C750,103.24 750.17,103.35 750.27,103.47Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478,436.09C477.449,436.378 477.022,436.859 476.8,437.44C476.49,438.44 476.36,438.44 475.03,439.25C474.96,438.49 475.67,438.04 475.54,437.25C475.35,436.03 476.76,435.41 478.11,436.01L478,436.09Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.52,504C418.56,503.938 417.632,503.635 416.82,503.12C416.47,502.84 415.93,502.63 416.18,502C416.43,501.37 417.07,501.63 417.59,501.68C418.86,501.83 418.79,503 419.52,504Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.14,510.58C421.05,510.31 421.79,510.58 421.83,511.66C421.83,512.39 421.11,512.36 420.59,512.37C419.48,512.37 418.74,511.78 418.85,511C418.91,510.55 419,510.52 420.14,510.58Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M888.38,167.58C889.12,167.41 889.64,167.92 890.04,168.66C890.21,168.98 890.21,169.25 889.9,169.46C889.635,169.632 889.279,169.576 889.08,169.33C888.92,169.19 889.08,168.28 888.43,169.03C888.09,169.46 887.68,169.57 887.29,169.03C887.028,168.756 886.92,168.37 887,168C887.22,167.36 887.75,167.56 888.38,167.58Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.77,668.44C592.43,669.61 590.77,669.23 589.84,670.32C589.7,670.48 589.39,670.24 589.33,670.01C589.275,669.8 589.275,669.58 589.33,669.37C590.66,669 591.8,667.64 593.77,668.44Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M946.53,338.13C946.53,338.85 945.8,339.22 945.36,339.37C944.69,339.59 944.2,338.92 944.07,338.29C943.87,337.29 944.8,337.44 945.3,337.29C946,337 946.23,337.6 946.53,338.13Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.79,602.47C493.794,602.47 493.798,602.47 493.801,602.47C494.273,602.47 494.661,602.858 494.661,603.33C494.661,603.377 494.658,603.424 494.65,603.47C494.634,604.21 494.066,604.83 493.33,604.91C492.71,604.91 492.33,604.3 492.4,603.78C492.456,603.054 493.062,602.483 493.79,602.47Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.53,84.85C636.86,86.08 636.86,86.1 638.77,85.49C639.055,85.342 639.409,85.439 639.58,85.71C639.82,86.1 639.47,86.27 639.2,86.4C638.855,86.601 638.485,86.755 638.1,86.86C636.6,87.24 636.22,87 635.53,84.85Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.37,269.64C600.37,271.21 598.37,271.64 598.43,273.64C597.33,272 598.11,270.9 601.37,269.64Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765.94,664.44C765.04,664.71 765.87,666 765.06,666.17C764.4,666.3 763.9,665.46 763.94,664.95C763.971,664.236 764.529,663.649 765.24,663.58C765.666,663.627 765.981,664.013 765.94,664.44Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M902.26,184.53C901.811,184.392 901.487,183.997 901.44,183.53C901.44,182.83 901.93,182.47 902.72,182.65C903.21,182.75 903.72,182.86 903.59,183.44C903.37,184.012 902.864,184.427 902.26,184.53Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.31,658.53C799.19,658.74 798.11,658.97 797.02,659.14C796.986,659.146 796.952,659.149 796.918,659.149C796.624,659.149 796.376,658.922 796.35,658.63C796.28,658.19 796.57,658.08 796.91,658.1C797.547,658.101 798.177,657.968 798.76,657.71C799.46,657.43 800,657.77 800.31,658.53Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.27,460.94C604.36,462.38 603.53,463.81 604.72,465.45C603.2,465.2 602.41,464.79 602.88,463.56C603.23,462.65 603.38,461.56 604.32,460.98L604.27,460.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.08,291.66C692.839,292.238 692.285,292.628 691.66,292.66C691,292.73 690.86,291.98 690.92,291.66C691.097,291.023 691.66,290.564 692.32,290.52C692.72,290.52 693,291.13 693.08,291.66Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.92,269.46C966.04,269.73 965.86,270.02 965.68,269.99C964.68,269.81 965.14,271.43 964.14,271.17C963.828,271.107 963.588,270.854 963.54,270.54C963.44,269.91 964.77,268.63 965.41,268.74C965.75,268.8 965.83,269.16 965.92,269.46Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M989.36,348.26C990.27,348.61 990.65,347.06 991.55,347.95C992.45,348.84 991.67,349.78 990.75,349.19C990.33,348.92 989.76,349.34 989.36,348.26Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.29,471.72C395.81,472.53 395.29,473.2 395.54,473.99C394.54,473.94 393.64,473.99 393.54,472.99C393.44,471.62 394.61,472 395.29,471.72Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.06,312.85C808.3,311.52 808.3,311.52 809.99,310.5C810.8,311.77 810.8,311.77 809.06,312.85Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M774.29,307.09C775.02,307.09 775.29,307.35 775.34,307.77C775.39,308.19 774.26,309.57 773.96,309.46C773.647,309.336 773.472,308.997 773.55,308.67C773.71,308.06 773.46,307.14 774.29,307.09Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882.16,326.71C881.6,326.62 880.96,326.43 880.94,325.84C880.963,325.347 881.375,324.953 881.869,324.953C881.943,324.953 882.018,324.962 882.09,324.98C882.55,325.1 883.29,325.18 883.34,325.86C883.39,326.54 882.66,326.56 882.16,326.71Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.18,538.35C976.43,539.54 976.18,540.84 977.47,541.58C974.4,540.22 974.32,540 976.18,538.35Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419,506.07C419.346,506.595 419.861,506.987 420.46,507.18C420.686,507.222 420.852,507.422 420.852,507.652C420.852,507.747 420.823,507.841 420.77,507.92C420.592,508.199 420.235,508.31 419.93,508.18C419.524,507.95 419.099,507.756 418.66,507.6C418.07,507.46 417.54,507.11 417.66,506.6C417.78,506.09 418.46,505.96 419.05,506.11L419,506.07Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M812.59,317.93C813.59,318.63 814.34,319.27 814.19,320.17C814.07,320.89 813.19,320.83 812.29,320.72C813.26,319.94 812.94,319 812.59,317.93Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M933.13,343.45L932.89,343.45C931.89,343.45 933.24,344.79 932.21,344.69C931.38,344.62 931.21,343.82 930.88,343.21C930.78,343.01 930.57,342.86 930.74,342.53C931.44,342.29 932.18,343.03 932.95,342.63C933.01,342.63 933.17,343.16 933.09,343.48L933.13,343.45Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.17,92.25C686.55,92.85 687.02,91.13 687.3,92.25C687.46,92.87 687.24,93.64 686.44,93.53C685.88,93.46 684.79,93.64 684.89,92.53C684.99,91.42 685.7,92.24 686.17,92.25Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.68,156.67C860.739,156.477 859.883,155.994 859.23,155.29C859.69,155.25 860.142,155.142 860.57,154.97C861.71,154.75 862,155.19 861.68,156.67Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.29,621.47C567.39,622.07 567.42,622.37 567.5,622.65C567.65,623.24 567.61,623.73 566.94,623.95C566.46,624.12 566.25,623.73 566.01,623.46C565.827,623.314 565.72,623.092 565.72,622.858C565.72,622.53 565.93,622.237 566.24,622.13L567.29,621.47Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.14,129.25C838.73,129.33 838.74,129.72 838.94,129.95C839.14,130.18 840.08,130.55 839.49,131.23C839.14,131.62 838.57,131.38 838.13,131.23C837.37,131 837.49,130.43 837.7,129.88C837.826,129.656 837.973,129.445 838.14,129.25Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.5,408.76C992.59,409.81 992.95,410.7 991.66,410.76C991.29,410.76 990.84,410.76 990.81,410.22C990.75,409.08 991.62,409.06 992.5,408.76Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.59,533.41C466.23,533.41 466.88,533.22 467.11,534.1C467.3,534.8 466.77,534.85 466.35,535.05C465.93,535.25 466,535.55 466.01,535.88C464.46,535.29 465.57,534.26 465.59,533.41Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M921.13,338.45C920.96,339.18 920.72,339.63 919.83,339.45C919.28,339.33 919.11,339.05 919.29,338.67C919.47,338.29 919.29,337.24 920.29,337.44C920.72,337.51 921.45,337.65 921.13,338.45Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M819.76,513.6C819.92,512.6 820.56,512.48 821.17,512.39C821.78,512.3 822.03,512.68 822.17,513.13C822.377,513.476 822.315,513.924 822.02,514.2C821.63,514.51 821.29,514.2 821.02,513.96C820.75,513.72 820.11,514.06 819.76,513.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.22,647.59C653.22,647.82 653.22,648.18 653.15,648.25C652.226,648.778 651.456,649.54 650.92,650.46C650.78,650.72 650.38,650.71 650.03,650.41C650.491,648.944 651.758,647.867 653.28,647.65L653.22,647.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.31,396.12C992.12,395.99 992.92,395.06 993.48,396C993.75,396.44 993.48,397 992.84,397.28C991.54,397.91 992,396.31 991.31,396.12Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M939.68,301.57C940.09,303.51 938.86,304.32 937.97,305.63C937.63,303.74 938.81,302.9 939.68,301.57Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1008.85,358.86C1007.93,357.02 1007.93,357.02 1009.55,355.81C1009.64,357 1008.77,357.82 1008.85,358.86Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.42,508.49C423.945,508.791 424.268,509.355 424.26,509.96C423.61,509.74 422.88,509.96 422.26,509.61C421.92,509.41 421.54,509.21 421.62,508.77C421.7,508.33 422.17,508.36 422.53,508.37C422.828,508.395 423.126,508.435 423.42,508.49Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447,208.62C446.86,209.05 446.79,209.41 446.38,209.35C445.61,209.23 445.43,208.61 445.38,207.99C445.38,207.67 445.71,207.47 446.03,207.45C447.06,207.37 446.65,208.33 447,208.62Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.81,212.4C891.81,213.3 891.74,214.11 891.02,214.18C890.02,214.28 890.15,213.18 889.44,212.42C890.221,212.591 891.032,212.584 891.81,212.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.08,74.35C707.91,72.95 709.35,73.35 710.08,72.48C710.279,72.572 710.456,72.705 710.6,72.87C710.78,73.14 710.52,73.29 710.33,73.38C709.347,73.975 708.228,74.309 707.08,74.35Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M991.5,469.69C991.8,470.81 991,471.34 990.81,472.07C990.71,472.48 991.02,473.12 990.17,472.71C989.877,472.637 989.669,472.372 989.669,472.07C989.669,471.872 989.758,471.685 989.91,471.56C990.42,471 990.64,470.13 991.5,469.69Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M952.2,248.69C951.82,248.61 951.6,248.36 951.64,248.05C951.74,247.17 952.45,247.05 953.14,246.94C953.145,246.94 953.151,246.94 953.156,246.94C953.452,246.94 953.696,247.184 953.696,247.48C953.696,247.507 953.694,247.533 953.69,247.56C953.58,248.44 952.67,248.3 952.2,248.69Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.94,191.41C872.334,191.371 872.706,191.614 872.83,191.99C873,192.37 873.48,192.73 873.05,193.21C872.926,193.3 872.771,193.336 872.62,193.31C872.137,193.31 871.736,192.922 871.72,192.44C871.7,192.09 871.54,191.68 871.94,191.41Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M954.18,251.4C955.01,251.59 955.66,250.24 956.44,251.24C957.01,251.99 956.16,252.24 955.82,252.46C954.63,253.23 954.94,251.56 954.18,251.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998.51,378C997.34,378.93 996.57,379.46 995.16,378.71C996.31,378.39 997,377.58 998.51,378Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.15,92.76C618.549,92.896 617.921,92.858 617.34,92.65C617.01,92.56 616.79,92.35 616.91,91.95C617.013,91.639 617.313,91.433 617.64,91.45C618.49,91.39 619,91.8 619.15,92.76Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M785.22,299.33C785.91,299.18 786.633,299.317 787.22,299.71C786.79,299.87 786.3,299.82 785.99,300.29C785.68,300.76 785.06,301.29 784.52,300.58C783.98,299.87 785,299.75 785.22,299.33Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.64,543C461.57,542.47 461.46,542.25 462.32,540.52C463.074,541.136 463.55,542.03 463.64,543Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M807.74,510.73C807.53,511.254 807.004,511.586 806.44,511.55C806.398,511.557 806.356,511.56 806.314,511.56C805.886,511.56 805.534,511.208 805.534,510.78C805.534,510.681 805.553,510.582 805.59,510.49C805.67,510.22 806.03,509.49 806.16,509.67C806.58,510.25 807.63,509.77 807.74,510.73Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M921.29,188.17C920.66,188.17 919.82,188.81 919.55,188.02C919.22,187.02 920.33,186.9 920.79,186.36C921.66,186.8 920.81,187.64 921.29,188.17Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.45,436.79C392.7,437.37 392.26,436.74 391.75,436.69C391.24,436.64 390.39,437.07 390.56,436.16C390.73,435.25 391.5,436.07 392,436.02C392.596,435.946 393.177,436.255 393.45,436.79Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.87,571.9C443.207,572.057 443.444,572.372 443.5,572.74C443.61,573.57 442.95,573.81 442.34,573.95C442.03,574.01 441.61,573.56 441.71,573.38C442.049,572.851 442.437,572.355 442.87,571.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M937.68,545.06C938.84,545.6 938.35,546.26 937.81,546.9C937.54,547.21 937.16,547.44 936.81,547.11C936.46,546.78 936.87,546.52 937.11,546.27C937.35,546.02 937.2,545.33 937.68,545.06Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M920.17,196.21C920.17,196.97 919.17,196.91 919.05,197.58C919.003,197.795 918.811,197.951 918.591,197.951C918.485,197.951 918.383,197.915 918.3,197.85C918.13,197.73 917.92,197.36 917.97,197.3C918.45,196.7 918.9,196.03 919.76,195.94C919.88,195.93 920,196.1 920.17,196.21Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M662.7,91.07C662.5,90.96 662.31,90.93 662.25,90.82C661.92,90.24 661.36,89.68 661.94,88.96C661.982,88.893 662.056,88.852 662.135,88.852C662.214,88.852 662.288,88.893 662.33,88.96C663,89.56 663.48,90.2 662.7,91.07Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631,93C631,93 631,93 631,93C630.588,93 630.25,92.661 630.25,92.25C630.25,92.243 630.25,92.237 630.25,92.23C630.19,91.52 630.79,91.56 631.25,91.52C631.284,91.515 631.318,91.512 631.353,91.512C631.709,91.512 632.003,91.805 632.003,92.162C632.003,92.181 632.002,92.201 632,92.22C632,92.73 631.53,92.93 631,93Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.72,504.81C414.233,505.209 413.605,505.393 412.98,505.32C412.963,505.322 412.946,505.322 412.928,505.322C412.632,505.322 412.388,505.079 412.388,504.782C412.388,504.768 412.389,504.754 412.39,504.74C412.386,504.418 412.607,504.135 412.92,504.06C413.618,503.877 414.358,504.186 414.72,504.81Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.81,584.05C463.19,584.22 463.41,584.25 463.46,584.36C463.8,585 464.96,585.03 464.75,586.05C464.659,586.173 464.513,586.244 464.36,586.24C463.42,585.87 463.1,585.09 462.81,584.05Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.33,341.12C972.33,339.92 972.33,339.92 973.99,339.32C973.369,340.241 972.415,340.886 971.33,341.12Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995.72,411C996.08,412 996.3,412.63 995.47,413C995.2,413.12 994.47,412.94 994.42,412.73C994.06,411.83 995,411.73 995.72,411Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M933.92,233.26C933.92,233.07 933.92,232.81 933.99,232.79C934.56,232.66 934.29,231.59 935.1,231.79C935.374,231.846 935.573,232.089 935.573,232.368C935.573,232.423 935.565,232.477 935.55,232.53C935.31,233.43 934.73,233.6 933.92,233.26Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932.69,535.16C932.19,535.09 931.86,534.87 931.86,534.58C931.86,533.9 931.92,533.17 932.68,532.84C932.9,532.75 933.24,532.92 933.2,533.13C933.08,533.83 932.86,534.51 932.69,535.16Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M988.41,450.08C988.41,449.94 988.41,449.72 988.55,449.67C989.121,449.448 989.661,449.156 990.16,448.8C990.223,448.749 990.301,448.721 990.382,448.721C990.54,448.721 990.679,448.827 990.72,448.98C990.78,449.19 990.83,449.58 990.72,449.63C990.127,450.09 989.409,450.361 988.66,450.41C988.58,450.4 988.5,450.2 988.41,450.08Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874,163.45C874.538,163.44 875.019,163.8 875.16,164.32C875.186,164.397 875.199,164.478 875.199,164.56C875.199,164.973 874.863,165.314 874.45,165.32C873.77,165.32 873.66,164.68 873.56,164.15C873.51,163.82 873.58,163.52 874,163.45Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M527.38,639.89C527.457,640.378 527.161,640.853 526.69,641C525.69,641.28 525.85,640.23 525.6,639.82C525.35,639.41 526.09,639.49 526.38,639.34C527,639 527.22,639.43 527.38,639.89Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M867.37,147.4C867.24,147.86 867.02,148.4 866.56,148.4C866.1,148.4 865.93,147.85 865.78,147.4C865.63,146.95 865.86,146.72 866.3,146.65C866.89,146.59 867.12,147 867.37,147.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.76,79.78C678.76,80.31 678.7,80.85 678.2,80.72C677.746,80.597 677.375,80.267 677.2,79.83C677.1,79.4 677.6,79.01 678.05,78.96C678.8,78.88 678.66,79.51 678.76,79.78Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M762.17,486C762.855,485.785 763.603,485.92 764.17,486.36C763.65,486.5 763.07,486.43 762.71,486.99C762.35,487.55 761.91,487.7 761.54,487.24C761,486.53 761.91,486.37 762.17,486Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.49,298.77C705,298.65 704.37,298.86 704.36,298.17C704.358,298.151 704.357,298.132 704.357,298.113C704.357,297.773 704.637,297.493 704.977,297.493C705.025,297.493 705.073,297.499 705.12,297.51C705.6,297.59 706.01,297.8 706.05,298.36C706.09,298.92 705.67,298.7 705.49,298.77Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M938.16,236.53C938.982,236.278 939.869,236.721 940.16,237.53C940.16,237.63 939.92,238 939.75,238.03C938.63,238.26 938.64,237.27 938.16,236.53Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905.11,191.5C905.49,192.34 906.31,192.86 905.33,193.5C905.009,193.755 904.54,193.72 904.26,193.42C903.9,193.08 903.86,192.87 904.4,192.6C904.67,192.48 904.79,192 905.11,191.5Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M948.43,337.84C948.96,338.52 948.36,339.17 948.43,339.84C947,338.86 947,338.86 948.43,337.84Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.11,438.42C506.45,438.48 506.8,438.64 506.63,439.01C506.46,439.38 506.46,440.09 505.99,440.16C505.52,440.23 505.2,439.7 505.08,439.22C505,439 505.76,438.43 506.11,438.42Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M953.77,256.18C954.324,256.229 954.784,256.636 954.9,257.18C955,257.53 954.64,257.72 954.34,257.78C953.64,257.93 953.34,257.5 953.28,256.89C953.262,256.835 953.252,256.777 953.252,256.72C953.252,256.432 953.482,256.192 953.77,256.18Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M839.62,319.88C838.78,319.88 838.97,319.21 838.74,318.88C838.51,318.55 838.83,318.17 839.24,318.11C839.284,318.102 839.328,318.098 839.372,318.098C839.74,318.098 840.05,318.383 840.08,318.75C840.153,319.183 839.974,319.621 839.62,319.88Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M928.12,339.53C928.12,340.11 927.67,340.1 927.34,340.23C927.01,340.36 926.56,340.53 926.53,339.87C926.53,339.54 926.53,339.19 926.88,339.12C927.337,338.977 927.838,339.143 928.12,339.53Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.86,500.56C789.86,500.27 790.3,500.61 790.5,501.34C790.62,501.76 790.6,502.17 790.13,502.34C789.66,502.51 789.52,502.03 789.47,501.66C789.405,501.232 789.188,500.842 788.86,500.56Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.45,457.17C592.07,456.02 592.7,455.71 593.56,456.07C593.67,456.07 593.8,456.38 593.76,456.44C593.23,457.23 592.4,456.94 591.45,457.17Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795,656.68C794.604,655.775 794.79,654.716 795.47,654C796,655.49 796,655.49 795,656.68Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993,426.27C993.4,427.2 992.4,427.47 992.62,428.19C992.16,427.61 991.36,427.87 990.95,427.14C991.562,426.704 992.261,426.407 993,426.27Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.93,106.11C789.83,106.65 789.78,107.25 789.03,107.24C788.8,107.24 788.67,107.01 788.7,106.73C788.76,106.17 788.86,105.6 789.5,105.47C789.9,105.39 790,105.78 789.93,106.11Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638.11,672.39C638.66,672.04 639.17,671.28 639.8,672.26C640.01,672.59 640.17,673.18 639.8,673.26C639.099,673.465 638.351,673.08 638.11,672.39Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.29,557.9C442.2,558.39 441.61,559.42 442.52,559.7C440.86,559.73 440.86,559.73 441.29,557.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.9,165.67C838.99,165.57 839.11,165.38 839.14,165.4C839.8,165.66 840.14,164.16 840.91,165.13C840.983,165.267 840.983,165.433 840.91,165.57C840.65,165.881 840.264,166.061 839.859,166.061C839.5,166.061 839.156,165.921 838.9,165.67Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.68,324.05C850.6,324.2 850.5,324.56 850.38,324.56C849.59,324.56 849.38,323.98 849.24,323.38C849.234,323.353 849.231,323.326 849.231,323.298C849.231,323.095 849.398,322.928 849.601,322.928C849.614,322.928 849.627,322.929 849.64,322.93C850.27,323 850.53,323.43 850.68,324.05Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724,85.78C724.67,86.19 725.31,86.53 724.77,87.39C724.595,87.663 724.234,87.756 723.95,87.6C723.17,87 723.9,86.45 724,85.78Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.2,304.28C731.91,304.18 731.72,303.91 731.83,303.76C732.09,303.475 732.379,303.218 732.69,302.99C732.97,302.73 733.29,302.36 733.6,302.89C733.91,303.42 733.46,303.52 733.08,303.69C732.768,303.857 732.473,304.055 732.2,304.28Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.55,438.28C467.71,437.41 468.42,437.47 469.02,437.44C469.19,437.44 469.44,437.66 469.53,437.84C469.7,438.21 469.45,438.39 469.1,438.45C468.57,438.53 468,438.71 467.55,438.28Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M999.2,409.07C999.011,408.997 998.827,408.91 998.65,408.81C998.29,408.54 997.72,408.45 997.65,407.9C997.65,407.77 997.94,407.51 998.14,407.46C998.93,407.25 999.02,407.96 999.26,408.46C999.34,408.53 999.25,408.71 999.2,409.07Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M914.33,200.84C914.46,201.06 914.6,201.26 914.71,201.47C914.89,201.84 915.51,202.14 914.98,202.64C914.86,202.75 914.53,202.64 914.32,202.64C913.59,202.44 913.62,201.95 913.9,201.39C914.032,201.198 914.176,201.015 914.33,200.84Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.07,617.38C504.79,616.49 504.59,615.83 504.38,615.14C506.13,615.46 506.16,615.55 505.07,617.38Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826.07,655.54L827.79,654.72C827.82,656.33 827.82,656.33 826.07,655.54Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.41,540.61C464.25,540.37 464.1,540.25 464.09,540.12C464.03,539.61 463.59,539.06 464.17,538.6C464.311,538.55 464.468,538.573 464.59,538.66C465.16,539.27 465.26,539.89 464.41,540.61Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M892.91,332.53C892.91,332.95 893.08,333.39 892.44,333.37C891.8,333.35 891.82,333.03 891.85,332.58C891.88,332.13 891.99,331.58 892.58,331.58C893.17,331.58 893,332.17 892.91,332.53Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849,316.61C848.182,316.386 847.626,315.617 847.67,314.77C847.714,313.923 847.81,314.67 847.87,314.68C848.92,314.92 848.7,315.89 849,316.61Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.77,516.63C879.77,517.24 879.11,517.12 878.77,517.39C878.43,517.66 878.17,517.32 878.12,517.03C878.02,516.37 878.57,516.34 879,516.26C879.43,516.18 879.65,516.18 879.77,516.63Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.1,289.38C676.98,289.8 676.8,290.21 676.24,290.2C675.84,290.2 675.76,289.85 675.77,289.55C675.769,289.537 675.769,289.523 675.769,289.51C675.769,289.137 676.076,288.83 676.449,288.83C676.456,288.83 676.463,288.83 676.47,288.83C676.49,288.828 676.51,288.827 676.53,288.827C676.837,288.827 677.091,289.074 677.1,289.38Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M912,240.26C910.61,240.2 910.32,239.63 910.19,238.7C911.21,238.67 911.26,239.53 912,240.26Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.62,532.48C464.57,532.02 464.62,531.67 465.23,531.83C465.84,531.99 466.17,532.16 465.96,532.83C465.856,533.044 465.732,533.249 465.59,533.44C465.09,533.28 464.67,533.07 464.62,532.48Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.82,205C919.82,205.56 920.45,205.77 920.5,206.48C920.5,206.64 919.94,207.03 919.8,206.96C919.17,206.65 919.25,205.93 918.82,205Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.93,466.59C405.243,466.34 404.777,465.691 404.76,464.96C404.76,464.9 405.04,464.76 405.16,464.78C406.12,465 406,465.72 405.93,466.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.75,147.84C511.31,147.84 511.31,148.3 511.41,148.6C511.61,149.16 511.06,149.17 510.75,149.31C510.25,149.54 510.1,149.16 509.99,148.77C509.8,148.09 510.46,148.12 510.75,147.84Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M801.43,312.45C801.313,312.673 801.054,312.786 800.81,312.72C800.362,312.542 800.103,312.063 800.2,311.59C800.26,311.19 800.61,311.26 800.92,311.31C801.23,311.36 801.69,311.5 801.43,312.45Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.33,140C869.24,140.38 869.22,140.77 868.78,140.7C868.34,140.63 868.17,140.07 867.95,139.7C868.198,139.519 868.475,139.384 868.77,139.3C869.41,139.21 869.11,139.84 869.33,140Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M749.53,490.21C749.3,490.02 749.04,489.9 748.97,489.72C748.816,489.176 749.097,488.596 749.62,488.38C749.79,488.27 750.07,488.5 750.13,488.74C750.211,489.302 749.981,489.865 749.53,490.21Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.78,384.18C996.483,384.91 995.796,385.411 995.01,385.47C995.42,384.5 995.42,384.5 996.78,384.18Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943.6,236.71C943.5,237.13 943.28,237.42 942.81,237.41C942.797,237.411 942.783,237.412 942.77,237.412C942.541,237.412 942.35,237.229 942.34,237C942.297,236.587 942.582,236.206 942.99,236.13C943,236.129 943.01,236.129 943.02,236.129C943.338,236.129 943.6,236.391 943.6,236.709C943.6,236.709 943.6,236.71 943.6,236.71Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M995.54,414.77C995.48,413.58 995.93,413.16 997.17,413.53C996.815,414.145 996.227,414.592 995.54,414.77Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M926.61,550.29C926.53,550.6 926.45,550.95 926.1,550.99C925.52,551.07 925.59,550.56 925.52,550.22C925.45,549.88 925.74,549.67 926.06,549.68C926.364,549.684 926.612,549.936 926.612,550.24C926.612,550.257 926.611,550.273 926.61,550.29Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.52,455.47C993.13,454.99 993.62,454.65 994.26,454.92C994.52,455.02 994.49,455.32 994.34,455.5C993.86,456.08 993.31,456.09 992.52,455.47Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M980,467.87C979.87,467.92 979.7,467.73 979.69,467.51C979.64,466.91 980.07,466.78 980.56,466.74C980.79,466.74 981.04,466.8 981.06,467.05C981.16,467.7 980.6,467.69 980,467.87Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.78,480C714.969,479.602 715.344,479.324 715.78,479.26C716.19,479.26 716.57,479.26 716.56,479.82C716.55,480.38 716.18,480.23 715.89,480.24C715.503,480.311 715.103,480.224 714.78,480Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526,645.05C525.75,644.86 525.66,644.82 525.63,644.76C525.33,644.2 524.54,643.76 525.16,642.97C525.283,642.909 525.427,642.909 525.55,642.97C526.22,643.47 526.16,644.14 526,645.05Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943.53,326.86C943.316,327.178 942.963,327.375 942.58,327.39C942.1,327.39 942.03,326.93 942.11,326.55C942.19,326.17 942.11,325.87 942.61,325.97C943.079,326.03 943.454,326.394 943.53,326.86Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.09,76.47C685.78,77.16 686.2,77.6 685.65,78.24C685.528,78.316 685.372,78.316 685.25,78.24C684.64,77.8 684.81,77.24 685.09,76.47Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.8,87.37C716.23,87.17 715.8,86.31 716.53,86.37C716.85,86.37 717.02,86.74 717.08,87.06C717.18,87.58 716.78,87.78 716.42,87.88C716.06,87.98 715.84,87.75 715.8,87.37Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790,94C789.93,94.9 789.65,95.38 788.91,95.43C788.81,95.43 788.61,95.25 788.61,95.16C788.64,94.4 789.16,94.15 790,94Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M743.61,99.27C743.53,99.74 743.4,100.09 742.88,100.01C742.561,99.974 742.322,99.691 742.34,99.37C742.372,98.968 742.727,98.661 743.13,98.69C743.58,98.69 743.53,99.06 743.61,99.27Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.44,205.65L885.6,205.23C885.3,205.23 885.28,204.87 885.1,204.71C885.27,203.92 885.79,203.94 886.32,204.28C886.632,204.374 886.848,204.663 886.848,204.989C886.848,205.268 886.69,205.525 886.44,205.65Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.85,438.32C473.338,438.273 473.783,438.624 473.85,439.11C473.692,439.246 473.49,439.321 473.282,439.321C472.887,439.321 472.539,439.052 472.44,438.67C472.36,438.43 472.59,438.3 472.85,438.32Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.17,96.77C644.87,96.86 644.7,96.68 644.72,96.45C644.72,95.92 645.18,95.69 645.63,95.53C646.08,95.37 646.06,95.68 646.05,95.87C646,96.41 645.61,96.61 645.17,96.77Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M939.05,246.71C939.358,246.797 939.553,247.105 939.5,247.42C939.502,247.436 939.503,247.452 939.503,247.468C939.503,247.698 939.313,247.888 939.083,247.888C939.008,247.888 938.934,247.868 938.87,247.83C938.639,247.745 938.485,247.523 938.485,247.277C938.485,247.199 938.5,247.122 938.53,247.05C938.62,246.83 938.77,246.65 939.05,246.71Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M989.16,474.31C988.77,474.24 988.68,473.96 988.74,473.63C988.752,473.365 988.974,473.154 989.239,473.154C989.294,473.154 989.348,473.162 989.4,473.18C989.594,473.298 989.717,473.504 989.73,473.73C989.732,473.747 989.733,473.764 989.733,473.782C989.733,474.072 989.493,474.312 989.203,474.312C989.188,474.312 989.174,474.311 989.16,474.31Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.45,205C924.344,205.308 924.064,205.524 923.74,205.55C923.34,205.55 923.21,205.23 923.29,204.9C923.37,204.57 923.51,204.25 923.89,204.32C924.198,204.409 924.422,204.68 924.45,205Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M947.63,328.8C947.51,329.08 947.42,329.38 947.04,329.39C947.033,329.39 947.026,329.39 947.019,329.39C946.717,329.39 946.469,329.142 946.469,328.84C946.469,328.83 946.469,328.82 946.47,328.81C946.475,328.496 946.736,328.24 947.05,328.24C947.45,328.22 947.53,328.52 947.63,328.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.84,480.68C716.93,481.23 716.47,481.68 715.67,481.5C716,480.61 716.55,480.46 717.84,480.68Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.29,278.76C610.11,279.21 609.73,279.23 609.36,279.15C609.219,279.105 609.123,278.974 609.123,278.826C609.123,278.747 609.15,278.671 609.2,278.61C609.337,278.329 609.659,278.185 609.96,278.27C610.17,278.34 610.36,278.48 610.29,278.76Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M912.59,333.82C912.35,333.82 912.11,333.74 912.12,333.48C912.12,332.95 912.57,332.74 913.01,332.58C913.45,332.42 913.42,332.74 913.42,332.93C913.421,332.947 913.421,332.963 913.421,332.98C913.421,333.438 913.048,333.815 912.59,333.82Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642.55,122.75C642.63,123.1 642.34,123.2 642.04,123.23C641.74,123.26 641.4,123.23 641.35,122.86C641.321,122.545 641.555,122.261 641.87,122.23C642.21,122.16 642.41,122.38 642.55,122.75Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.24,147.68C870.74,147.68 870.89,148.11 871.01,148.49C871.026,148.53 871.034,148.572 871.034,148.614C871.034,148.801 870.88,148.954 870.694,148.954C870.676,148.954 870.658,148.953 870.64,148.95C870.14,148.95 870.08,148.47 869.92,148.13C869.76,147.79 870,147.74 870.24,147.68Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M926.68,337.16C926.682,337.175 926.683,337.19 926.683,337.205C926.683,337.397 926.525,337.555 926.333,337.555C926.298,337.555 926.263,337.55 926.23,337.54C925.85,337.47 925.79,337.14 925.81,336.82C925.83,336.5 925.89,336.33 926.21,336.43C926.53,336.53 926.64,336.84 926.68,337.16Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.43,337C971.43,336.77 971.43,336.36 971.81,336.36C972.19,336.36 972.38,336.78 972.45,337.18C972.515,337.413 972.381,337.658 972.15,337.73C971.69,337.81 971.46,337.52 971.43,337Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.4,168.15C523.714,168.212 523.941,168.49 523.94,168.81C523.94,168.818 523.941,168.826 523.941,168.833C523.941,169.047 523.765,169.223 523.551,169.223C523.534,169.223 523.517,169.222 523.5,169.22C523.175,169.189 522.928,168.906 522.94,168.58C522.94,168.33 523.16,168.21 523.4,168.15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.27,506.93C411.15,507.32 410.91,507.59 410.45,507.49C410.27,507.49 409.99,507.38 410.16,507.04C410.271,506.748 410.539,506.542 410.85,506.51C411.15,506.48 411.23,506.66 411.27,506.93Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M787.26,110.37C787.197,110.772 786.915,111.108 786.53,111.24C786.24,111.34 785.87,111.24 785.89,110.9C785.93,110.505 786.263,110.198 786.66,110.19C786.868,110.218 787.071,110.279 787.26,110.37Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M781.8,92.13C781.545,92.085 781.365,91.848 781.39,91.59C781.353,91.183 781.637,90.811 782.04,90.74C782.046,90.74 782.052,90.74 782.058,90.74C782.25,90.74 782.408,90.898 782.408,91.09C782.408,91.127 782.402,91.164 782.39,91.2C782.223,91.528 782.025,91.839 781.8,92.13Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.46,88.71C654.12,88.56 653.77,88.46 653.82,88.06C653.87,87.66 654.16,87.57 654.49,87.68C654.793,87.799 654.992,88.094 654.99,88.42C655,88.49 654.63,88.62 654.46,88.71Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.44,674.91C768.111,674.964 767.796,674.739 767.74,674.41C767.63,674.09 767.89,674.01 768.08,673.92C768.158,673.878 768.245,673.856 768.333,673.856C768.565,673.856 768.772,674.008 768.84,674.23C768.859,674.284 768.868,674.341 768.868,674.398C768.868,674.649 768.687,674.866 768.44,674.91Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.5,458.24C558.59,458.86 557.96,458.85 557.31,458.33C557.93,457.7 558.57,458.05 559.5,458.24Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M792.39,307.86C792.39,308.1 792.31,308.31 792.02,308.35C791.987,308.356 791.953,308.359 791.919,308.359C791.621,308.359 791.371,308.127 791.35,307.83C791.28,307.53 791.5,307.41 791.73,307.37C791.785,307.35 791.843,307.339 791.901,307.339C792.17,307.339 792.391,307.56 792.391,307.829C792.391,307.839 792.391,307.85 792.39,307.86Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.9,569.56C488.23,569.75 488.59,569.91 488.66,570.36C488.663,570.38 488.664,570.4 488.664,570.42C488.664,570.639 488.489,570.822 488.27,570.83C487.93,570.89 487.66,570.78 487.66,570.36C487.66,569.94 487.58,569.76 487.9,569.56Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.11,572.75C462.64,572.81 462.76,573.06 462.69,573.43C462.62,573.8 462.57,573.9 462.25,573.81C461.929,573.749 461.707,573.444 461.75,573.12C461.77,572.82 462,572.74 462.11,572.75Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M914.42,207C914.276,207.154 914.107,207.283 913.92,207.38C913.43,207.54 913.22,207.19 913.1,206.82C912.98,206.45 913.22,206.38 913.48,206.46C913.74,206.54 914.27,206.43 914.42,207Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451,587.14C451,587.44 450.82,587.55 450.6,587.59C450.13,587.67 450.13,587.26 450.13,587C450.13,586.74 450.06,586.3 450.56,586.43C450.844,586.546 451.023,586.834 451,587.14Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M934.43,540.22C934.54,540.36 934.75,540.52 934.78,540.71C934.86,541.19 934.42,541.06 934.17,541.13C933.92,541.2 933.72,541.06 933.75,540.79C933.8,540.457 934.094,540.211 934.43,540.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.51,193.88C909.43,194.02 909.36,194.23 909.29,194.23C908.888,194.276 908.508,194.027 908.39,193.64C908.387,193.508 908.451,193.384 908.56,193.31C909,193.27 909.26,193.56 909.51,193.88Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.1,252.72C922.96,253.81 922.96,253.88 922.03,254.12L922.1,252.72Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M729.86,293.81C729.794,294.005 729.591,294.121 729.39,294.08C729.19,294.08 728.87,293.89 728.86,293.76C728.858,293.74 728.857,293.721 728.857,293.701C728.857,293.427 729.082,293.201 729.357,293.201C729.388,293.201 729.419,293.204 729.45,293.21C729.68,293.23 729.87,293.43 729.86,293.81Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.94,93.79C754.94,94.13 754.83,94.31 754.59,94.33C754.19,94.33 754.05,94.07 754.06,93.75C754.06,93.745 754.06,93.739 754.06,93.734C754.06,93.547 754.213,93.394 754.4,93.394C754.444,93.394 754.489,93.403 754.53,93.42C754.75,93.49 755,93.57 754.94,93.79Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.92,665.41C603.01,665.82 602.71,665.93 602.42,666.04C602.13,666.15 601.98,665.96 601.92,665.74C601.83,665.34 602.14,665.21 602.43,665.08C602.72,664.95 602.81,665.22 602.92,665.41Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M812.7,316C812.9,316.07 813.2,316.09 813.04,316.41C812.932,316.603 812.773,316.762 812.58,316.87C812.27,317.05 812.15,316.76 812.12,316.57C812.08,316.21 812.37,316.08 812.7,316Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.37,321.22C875.53,321.42 875.81,321.63 875.88,321.9C875.95,322.17 875.69,322.45 875.34,322.4C874.99,322.35 874.9,322.04 874.98,321.72C875.06,321.4 875,321.28 875.37,321.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M969,293.17C969.321,293.208 969.581,293.452 969.64,293.77C969.64,293.99 969.54,294.27 969.29,294.25C968.964,294.22 968.701,293.965 968.66,293.64C968.58,293.37 968.72,293.22 969,293.17Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932.15,342C931.5,342 931.3,341.86 931.27,341.62C931.24,341.38 931.46,341.07 931.82,341.05C931.837,341.048 931.854,341.047 931.872,341.047C932.088,341.047 932.271,341.214 932.29,341.43C932.322,341.631 932.271,341.836 932.15,342Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1002.76,345.6C1002.67,345.82 1002.53,345.99 1002.26,345.91C1001.99,345.83 1001.79,345.79 1001.93,345.47C1002,345.246 1002.22,345.1 1002.45,345.12C1002.64,345.135 1002.78,345.292 1002.78,345.479C1002.78,345.52 1002.77,345.561 1002.76,345.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.08,436C478.46,436 478.61,436.25 478.66,436.57C478.66,436.63 478.47,436.8 478.39,436.79C478.04,436.7 477.96,436.41 477.97,436.09L478.08,436Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419,506.11L419.17,504.91C419.44,505.44 419.63,505.86 418.95,506.07L419,506.11Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.22,332.88C918.6,332.72 918.99,332.61 919.22,333.11C919.22,333.2 919.12,333.45 919.04,333.46C918.59,333.53 918.27,333.37 918.27,332.85L918.22,332.88Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.28,314.25L659,319.64C659.79,319.8 660.57,319.93 661.35,320.1C663.11,320.49 663.13,320.51 662.77,322.32C661.47,328.987 660.163,335.653 658.85,342.32C657.36,349.92 655.85,357.52 654.37,365.13C654.168,365.621 654.216,366.181 654.5,366.63C655.03,365.63 655.5,364.78 656.01,363.88C662.677,351.147 669.343,338.41 676.01,325.67C676.27,325.17 676.56,324.67 676.79,324.18C676.95,323.686 677.413,323.349 677.932,323.349C678.06,323.349 678.188,323.37 678.31,323.41C687.723,325.29 697.13,327.153 706.53,329C706.681,329.061 706.825,329.138 706.96,329.23C706.748,330.08 706.367,330.88 705.84,331.58C697,347.333 688.14,363.07 679.26,378.79C678.437,380.156 678.085,381.755 678.26,383.34C679.673,397.253 681.053,411.17 682.4,425.09C683.22,433.443 684.027,441.797 684.82,450.15C684.983,450.737 684.923,451.365 684.65,451.91C682.467,451.708 680.304,451.334 678.18,450.79C670.09,449.26 662.02,447.65 653.94,446.07C651.94,445.68 651.94,445.68 651.86,443.62C651.073,427.167 650.277,410.717 649.47,394.27C649.467,393.613 649.32,392.964 649.04,392.37C648.36,395.8 647.67,399.22 647.04,402.64C644.5,415.567 641.963,428.497 639.43,441.43C639.11,443.07 639.08,443.11 637.5,442.81L609,437.27C607.22,436.92 607.2,436.87 607.57,434.93C609.21,426.46 610.72,417.93 612.57,409.54C613.44,405.54 613.95,401.46 614.85,397.46C615.75,393.46 616.49,389.16 617.3,385C618.11,380.84 618.9,376.85 619.69,372.78C623.39,353.813 627.093,334.843 630.8,315.87C630.91,315.4 631.08,315 631.28,314.25Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498,289.77C497.06,294.52 496,299.69 495,304.87C491.253,324.07 487.507,343.273 483.76,362.48C482.427,369.447 481.063,376.42 479.67,383.4C479.606,383.875 479.516,384.345 479.4,384.81C479.02,385.98 479.3,386.48 480.63,386.71C485.43,387.55 490.2,388.57 494.98,389.48C498.47,390.15 498.47,390.13 497.8,393.59C496.58,399.86 495.39,406.14 494.16,412.41C493.71,414.75 493.68,414.77 491.46,414.33C478.047,411.71 464.64,409.08 451.24,406.44C448.81,405.96 446.39,405.44 443.95,405.04C442.74,404.85 442.35,404.44 442.61,403.18C443.49,399.04 444.27,394.88 445.08,390.72C449.007,370.66 452.933,350.597 456.86,330.53L466.01,283.74C466.32,282.12 466.34,282.08 468.01,282.4C477.503,284.22 486.993,286.063 496.48,287.93C497.2,288.07 498.46,287.87 498,289.77Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.18,401.92C809.8,400.39 810.3,398.92 810.62,397.49C810.74,396.95 810.96,396.98 811.43,397.15C811.9,397.32 812.32,397.15 811.77,396.59C810.99,395.85 811.07,395.41 812.13,395.14C812.13,395.14 812.24,394.76 812.13,394.7C811.65,394.33 810.99,394.14 811.34,393.24C811.542,392.55 811.683,391.844 811.76,391.13C811.91,390.35 812.06,389.57 812.22,388.78L812.64,386.67C814.86,375.39 817.077,364.107 819.29,352.82C819.63,351.05 819.64,351.05 821.41,351.39C830.82,353.22 840.23,355.07 849.64,356.87C851.64,357.26 851.51,357.5 851.18,359.18C845.06,390.393 838.977,421.58 832.93,452.74C832.32,455.85 832.16,455.34 835.03,455.87C839.97,456.8 844.91,457.78 849.84,458.77C851.78,459.15 851.84,459.2 851.46,461.06C850.127,468.027 848.75,474.997 847.33,481.97C846.98,483.73 846.94,483.74 845.15,483.39L810.15,476.5C805.92,475.67 801.68,474.85 797.45,474.01C795.73,473.67 795.72,473.64 796.02,472.07C797.8,462.983 799.583,453.893 801.37,444.8C802.623,438.38 803.87,431.953 805.11,425.52C806.537,418.187 807.96,410.853 809.38,403.52C809.424,402.902 809.712,402.326 810.18,401.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.69,364.72C894.69,365.72 899.69,366.64 904.69,367.62C907.357,368.14 910.023,368.673 912.69,369.22C913.19,369.32 913.77,369.22 914.05,369.94C914.33,370.66 914.92,371.03 915.57,370.09C915.826,369.902 916.153,369.839 916.46,369.92C918.696,370.289 920.912,370.769 923.1,371.36L919.23,386.76C913.09,411.133 906.943,435.503 900.79,459.87C900.72,460.18 900.63,460.49 900.54,460.8C900.06,462.61 900.05,462.63 898.33,462.3C893.23,461.307 888.137,460.307 883.05,459.3C881.41,458.98 879.75,458.68 878.12,458.3C876.49,457.92 876.42,457.9 876.63,456.3C876.94,454.01 877.27,451.72 877.63,449.42C879.703,434.64 881.77,419.857 883.83,405.07C885.597,392.403 887.37,379.737 889.15,367.07C889.171,366.258 889.355,365.459 889.69,364.72Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M901.18,470.12C900.27,474.77 899.32,479.71 898.36,484.64C897.92,486.91 897.49,489.18 897.03,491.45C896.65,493.39 896.63,493.45 894.71,493.05C888.71,491.88 882.66,490.68 876.63,489.5C874.28,489.04 871.93,488.58 869.57,488.16C868.47,487.96 867.97,487.62 868.24,486.3C869.733,479.107 871.147,471.903 872.48,464.69C872.7,463.56 873.09,463.26 874.22,463.48C882.82,465.207 891.43,466.91 900.05,468.59C900.76,468.73 901.58,468.73 901.18,470.12Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.18,401.92C809.9,402.43 809.63,402.92 809.35,403.47C809.19,402.72 809.26,402.09 810.18,401.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.05,522.44C515.68,521.95 516.29,521.44 517.18,521.71C517.361,520.972 517.801,520.322 518.42,519.88C524.927,514.98 531.417,510.05 537.89,505.09C538.79,504.4 539.3,504.38 540,505.33C541.833,507.85 543.72,510.33 545.66,512.77C546.4,513.7 546.24,514.17 545.33,514.85C540.46,518.49 535.64,522.18 530.8,525.85L505.8,544.85C505.16,545.33 504.51,545.79 503.71,546.38L499.49,540.84C497.603,538.36 495.72,535.877 493.84,533.39C492.84,532.02 492.84,531.98 494.05,530.7C498.7,525.96 503.37,521.25 508.05,516.52C508.5,516.07 508.93,515.6 509.57,514.92C508.84,514.988 508.145,515.266 507.57,515.72C501.883,518.98 496.217,522.25 490.57,525.53C488.73,526.58 488.71,526.58 487.39,524.84C484.583,521.147 481.78,517.453 478.98,513.76C478.6,513.26 478.25,512.76 477.78,512.06L520.49,479.61C522.81,482.68 525.01,485.61 527.26,488.5C527.95,489.38 527.37,489.75 526.78,490.2C523.587,492.613 520.403,495.03 517.23,497.45L503.88,507.62C503.44,507.95 503.01,508.31 502.37,508.83C503.292,508.854 504.191,508.533 504.89,507.93C512.96,503.37 521,498.77 529.07,494.21C530.86,493.21 530.59,492.88 532.07,494.83C533.13,496.23 534.16,497.66 535.27,499.02C535.87,499.76 535.98,500.27 535.27,501.02C529.463,506.86 523.69,512.733 517.95,518.64C517.28,519.32 516.07,519.19 515.8,519.92C515.627,520.683 515.234,521.378 514.67,521.92C514.17,522.86 513.51,523.09 512.67,522.35L512.61,522.66C513.39,523.62 514.2,522.45 515.05,522.44Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.24,567.32C803.6,573.91 807.64,580.03 811.86,586.4L802.38,592.69C801.52,592.33 801.29,591.6 800.9,591.01C791.84,577.363 782.793,563.697 773.76,550.01C773.597,549.734 773.42,549.467 773.23,549.21C772.59,548.46 772.59,547.9 773.51,547.31C776.277,545.55 779.013,543.743 781.72,541.89C781.957,541.668 782.27,541.544 782.596,541.544C782.987,541.544 783.357,541.723 783.6,542.03C783.951,542.358 784.318,542.669 784.7,542.96L799.05,554.96C799.653,555.529 800.394,555.932 801.2,556.13C797.09,549.92 792.98,543.71 788.73,537.27L798.3,531C798.943,531.561 799.472,532.24 799.86,533L826.73,573.57L827.13,574.17C828.04,575.53 828.47,575.48 826.62,576.68C824.28,578.21 821.92,579.68 819.62,581.33C819.299,581.625 818.878,581.789 818.442,581.789C817.934,581.789 817.45,581.566 817.12,581.18C812.03,577.05 806.89,572.99 801.75,568.91C801.041,568.202 800.183,567.659 799.24,567.32Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.54,577.75C759.16,574.44 757.8,571.21 756.47,567.97C756.16,567.2 755.77,567.11 755.01,567.43C752.6,568.49 750.14,569.43 747.73,570.49C746.84,570.9 746.46,570.7 746.12,569.84C745.12,567.24 744.12,564.65 742.93,562.1C742.52,561.16 742.81,560.86 743.63,560.52C750.63,557.64 757.57,554.73 764.45,551.87C765.25,552.08 765.26,552.75 765.45,553.22C771.89,568.6 778.317,583.987 784.73,599.38C785.5,601.23 785.5,601.26 783.79,601.97C777.68,604.53 771.55,607.05 765.46,609.66C764.31,610.15 763.81,609.98 763.36,608.79C762.3,605.97 761.09,603.21 759.89,600.31L768.42,596.69C767.21,593.77 766.03,590.94 764.85,588.11C764.55,587.38 764.02,587.53 763.46,587.76C761.55,588.56 759.61,589.3 757.73,590.18C756.73,590.64 756.33,590.41 755.95,589.45C755.03,587.07 754.05,584.713 753.01,582.38C752.63,581.52 752.76,581.15 753.64,580.77C755.996,579.897 758.3,578.889 760.54,577.75Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.3,562.59C545.46,563.06 545.12,563.33 544.87,563.59C541.99,567.01 539.103,570.427 536.21,573.84C535.967,574.089 535.706,574.319 535.43,574.53L517.75,559.6L524.75,551.38C526.87,553.17 528.84,554.79 530.75,556.47C531.46,557.1 531.98,557.34 532.69,556.47C534.29,554.47 535.95,552.53 537.63,550.61C538.25,549.9 538.23,549.44 537.5,548.85C535.88,547.55 534.33,546.16 532.71,544.85C532.04,544.31 531.82,543.85 532.49,543.12C534.44,540.91 536.32,538.63 538.37,536.21C540.26,537.81 542.11,539.3 543.88,540.89C544.72,541.64 545.23,541.68 545.98,540.74C548.08,538.13 550.28,535.61 552.62,532.84C551.17,531.6 549.79,530.44 548.41,529.27C547.5,528.49 546.6,527.7 545.66,526.95C545.06,526.47 544.89,526.06 545.47,525.39C547.56,522.98 549.61,520.54 551.76,518L570.19,533.56C569.78,534.1 569.47,534.56 569.12,534.98C561.64,543.833 554.157,552.683 546.67,561.53C546.3,561.98 546.09,562.7 545.3,562.66L545.17,562.51L545.3,562.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.85,613.15L697.11,613.15C699.22,613.15 699.23,613.15 699.27,615.15C699.32,617.39 699.35,619.63 699.38,621.86C699.38,623.86 699.38,623.86 697.28,623.95C692.88,624.05 688.48,624.09 684.09,624.19C681.53,624.19 678.97,624.31 676.42,624.45C675.28,624.52 674.87,624.13 674.88,622.98C674.88,620.1 674.82,617.22 674.76,614.35C674.793,613.472 674.965,612.604 675.27,611.78L683.66,583.56C683.971,582.899 684.099,582.167 684.03,581.44L675.91,581.44C673.97,581.44 673.91,581.44 673.91,579.53C673.91,577.06 673.91,574.58 673.76,572.1C673.76,571.1 674.09,570.75 675.12,570.73C682.71,570.59 690.3,570.44 697.89,570.2C699.22,570.2 699.4,570.67 699.5,571.83C699.789,575.729 699.338,579.648 698.17,583.38C695.41,592.63 692.89,601.95 690.28,611.25C690.11,611.87 690,612.49 689.85,613.15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.46,550.48C571.434,547.642 573.163,545.121 575.46,543.19C577.571,541.478 580.504,541.164 582.93,542.39C586.77,544.01 590.13,546.39 593.84,548.62L589.09,556.33C588.78,556.33 588.69,556.39 588.64,556.33C584.84,554.17 584.16,554.33 581.8,558.12C575.38,568.507 568.983,578.917 562.61,589.35C562.32,589.83 561.99,590.29 561.73,590.78C561.39,591.44 560.98,591.45 560.38,591.08C557.06,589.02 553.73,586.95 550.38,584.95C549.38,584.36 549.58,583.84 550.07,583.04C553.44,577.61 556.76,572.16 560.07,566.71C562.95,562.01 565.833,557.317 568.72,552.63C569.097,551.745 569.714,550.983 570.5,550.43L570.46,550.48Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.94,622.06C714.252,619.167 713.718,616.24 713.34,613.29C710.98,599.29 708.647,585.29 706.34,571.29C706.27,570.9 706.18,570.51 706.11,570.11C706,569.44 706.26,569.11 706.97,568.99C710.83,568.37 714.69,567.73 718.55,567.07C719.42,566.93 719.83,567.14 719.99,568.07C721.2,575.56 722.48,583.07 723.71,590.51C723.8,591.02 724.11,591.65 723.49,592.04C723.19,592.23 723.23,592.47 723.35,592.6C725.1,594.36 724.67,596.75 725.06,598.85C726.26,605.28 727.17,611.77 728.33,618.21C728.56,619.52 728.21,619.91 727.05,620.1C723.06,620.71 719.05,621.38 714.94,622.06Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.51,533.08C642.106,531.88 643.776,530.781 645.51,529.79C647.71,528.939 648.985,526.6 648.51,524.29C648.428,522.623 648.455,520.953 648.59,519.29C648.642,519.08 648.722,518.878 648.83,518.69C649.911,519.314 650.917,520.059 651.83,520.91C652.749,521.546 653.618,522.252 654.43,523.02C655.332,524.06 656.828,524.372 658.07,523.78C660.22,522.99 662.46,522.42 665.15,521.62C664.569,523.524 663.871,525.391 663.06,527.21C661.85,529.55 661.99,531.51 663.84,533.42C664.511,534.212 665.11,535.062 665.63,535.96C665.87,536.33 666.25,536.63 665.97,537.23C665.78,537.61 665.97,537.7 667.09,538.01C664.922,538.381 662.708,538.381 660.54,538.01C658.817,537.557 656.994,538.356 656.16,539.93C655,541.73 653.58,543.36 652.08,545.34C651.218,543.252 650.588,541.076 650.2,538.85C649.999,537.087 648.649,535.659 646.9,535.36C644.89,534.78 642.93,533.94 640.51,533.08Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.41,504.93C578.41,503.62 580.08,502.42 581.84,501.35C582.779,500.894 583.342,499.9 583.25,498.86C583.25,496.86 583.25,494.78 583.35,492.19C585.35,493.77 586.92,494.92 588.35,496.25C589.189,497.117 590.487,497.37 591.59,496.88C593.45,496.24 595.35,495.73 597.66,495.03C596.78,497.35 596.09,499.27 595.31,501.16C594.83,502.082 594.957,503.208 595.63,504C596.88,505.62 597.97,507.35 599.34,509.34C597.227,509.451 595.108,509.367 593.01,509.09C591.896,508.876 590.762,509.391 590.19,510.37C589.007,512.152 587.669,513.825 586.19,515.37C585.63,513.37 584.99,511.65 584.68,509.87C584.524,508.339 583.342,507.099 581.82,506.87C580.1,506.4 578.42,505.65 576.41,504.93Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.5,523.34C732.58,522.6 733.86,522.52 735.34,522.02C734.87,523.49 735,524.96 733.42,525.61C733.283,525.684 733.158,525.778 733.05,525.89C734.3,527.56 731.76,529.61 733.78,531.38C735.15,532.59 735.97,534.38 737.3,536.38C734.76,536.26 732.71,536.23 730.67,536.05C729.717,535.876 728.748,536.301 728.23,537.12C727.04,538.81 725.74,540.43 724.31,542.3C723.504,540.624 722.948,538.838 722.66,537C722.515,535.39 721.302,534.065 719.71,533.78C717.941,533.269 716.202,532.661 714.5,531.96C715.994,530.617 717.646,529.462 719.42,528.52C720.577,527.96 721.263,526.728 721.13,525.45C721.04,523.52 721.61,521.61 721.23,519.14C723.06,520.6 724.45,521.76 725.9,522.85C726.58,523.37 727.1,524.17 728.08,524.21C729.17,523.7 730.7,525 731.5,523.34Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.05,522.44C514.39,523.44 513.27,523.95 512.14,524.82C512.19,524.099 512.136,523.375 511.98,522.67C511.6,521.67 511.98,521.07 512.84,520.97C513.09,520.97 513.2,520.97 513.28,521.32C513.51,522.25 513.55,522.24 514.55,521.92C514.596,522.178 514.794,522.384 515.05,522.44Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.5,523.34C731.86,524.2 731.13,524.41 730.65,524.79C730.17,525.17 729.88,524.89 729.65,524.6C729.2,524.07 728.65,524.32 728.09,524.19C729.09,523.38 730.37,523.65 731.5,523.34Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M851,248.35L827.3,265.62L820.07,255.8L863.36,224C866.01,227.6 868.57,231.05 871.1,234.53C872.19,235.781 873.118,237.166 873.86,238.65C872.75,239.8 871.68,240.98 870.55,242.1C866.463,246.14 862.367,250.173 858.26,254.2C858.01,255.2 855.93,255.58 857.45,257.08C857.56,257.34 857.67,257.01 857.56,256.97C857.149,256.845 856.903,256.418 857,256C857.33,254.81 858.16,254.63 859.21,255C859.5,255.29 860.21,255.88 860.07,255.16C859.85,254.01 860.44,253.82 861.07,253.45C866.3,250.54 871.56,247.68 876.75,244.71C877.89,244.05 878.39,244.41 879.04,245.31C881.13,248.22 883.3,251.09 885.4,254C885.77,254.52 886.4,254.94 886,255.87C885.71,256.49 886.67,256.64 887,256.96C888.91,258.62 888.94,258.58 886.86,260.11C875.727,268.277 864.597,276.45 853.47,284.63C850.91,286.52 848.34,288.4 845.52,290.46C843.11,287.19 840.76,284.01 838.28,280.63C841.8,278.037 845.257,275.49 848.65,272.99C849.29,273.23 848.84,273.73 849.1,273.99C849.29,274.11 849.44,274.06 849.41,273.89C849.251,272.936 849.724,271.981 850.58,271.53C854.39,268.77 858.17,265.95 861.95,263.16C862.115,262.802 862.323,262.467 862.57,262.16C862.09,262.6 861.44,262.31 861,262.68C853,267.04 845.023,271.393 837.07,275.74C835.99,276.33 835.99,276.3 834.76,275.32C832.86,273.8 831.87,271.58 830.27,269.7L851.44,248.8C851.577,248.386 851.814,248.011 852.13,247.71C851.791,247.985 851.41,248.201 851,248.35Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.7,218C591.42,220.1 588.36,222 585.38,224C584.38,224.72 583.8,224.13 583.14,223.56L568.26,210.69L566.26,208.95C566.245,209.526 566.441,210.088 566.81,210.53C570.303,215.99 573.787,221.443 577.26,226.89C578.26,228.51 578.26,228.53 576.64,229.58C574.36,231.06 572.02,232.45 569.79,234C568.71,234.74 568.21,234.5 567.56,233.47C563.25,226.65 558.88,219.87 554.56,213.07L540.37,190.84C540.032,190.442 539.823,189.95 539.77,189.43C542.66,187.58 545.63,185.71 548.55,183.77C549.55,183.14 550.01,183.77 550.55,184.26L565.18,196.26C566.044,197.042 567.035,197.671 568.11,198.12C564.11,191.8 560.06,185.47 555.95,179.01L565.78,172.73C575.42,187.84 585,202.84 594.7,218Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.35,225.94C833.05,228.59 830.9,231.05 828.77,233.49C827.882,233.023 827.074,232.415 826.38,231.69C825.8,231.24 825.17,230.8 826.12,230.06C826.236,229.971 826.304,229.833 826.304,229.687C826.304,229.504 826.197,229.337 826.03,229.26C825.83,229.15 825.44,229.05 825.37,229.13C824.37,230.3 823.73,229.36 823.02,228.77C822.712,228.431 822.287,228.22 821.83,228.18C819.6,230.74 817.31,233.4 814.97,236.02C814.35,236.71 814.63,237.1 815.18,237.57C817,239.137 818.81,240.713 820.61,242.3C821.99,243.53 821.99,243.55 820.85,244.87C819.18,246.81 817.48,248.72 815.85,250.67C815.32,251.29 814.85,251.61 814.11,250.91C808.417,245.883 802.713,240.883 797,235.91C796.95,235.86 796.94,235.77 796.87,235.6C801.04,230.82 805.21,225.97 809.46,221.19C811.09,219.36 812.46,217.26 814.64,215.95C815.32,215.54 815.3,214.4 815.94,213.68C820.94,208.07 825.85,202.38 830.8,196.68C832.03,195.28 832.09,195.24 833.52,196.58C835.66,198.58 837.83,200.63 840.05,202.5C842.59,204.64 845.05,206.88 847.71,208.94C848.33,209.43 848.87,210.01 849.53,210.63L842.53,218.63L835.44,212.63C833.44,214.98 831.44,217.27 829.44,219.52C828.78,220.25 829.26,220.62 829.76,221.06L835.35,225.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611.44,210.92C609.16,211.83 606.89,212.77 604.59,213.64C602.14,214.58 602.59,214.95 601.48,212.23C596.64,200.15 591.813,188.073 587,176C585.67,172.66 584.4,169.3 583,166C582.53,164.89 582.81,164.47 583.84,164.07C590.16,161.603 596.463,159.097 602.75,156.55C603.82,156.11 604.31,156.29 604.75,157.37C605.67,159.83 606.62,162.29 607.68,164.7C608.18,165.85 607.77,166.22 606.77,166.59C604.39,167.48 602.04,168.47 599.53,169.48C600.7,172.42 601.81,175.22 602.91,178.03C603.17,178.69 603.53,178.81 604.2,178.53C606.2,177.69 608.2,176.94 610.2,176.12C611.02,175.78 611.51,175.91 611.85,176.8C612.79,179.26 613.78,181.7 614.76,184.14C615.06,184.88 614.91,185.31 614.12,185.61C612.18,186.34 610.28,187.18 608.33,187.89C607.39,188.23 607.08,188.6 607.52,189.63C608.72,192.41 609.84,195.23 610.9,198.07C611.27,199.07 611.72,199.28 612.67,198.88C615.03,197.88 617.43,197.03 619.78,196.02C620.67,195.63 621.06,195.79 621.4,196.66C622.51,199.56 623.67,202.44 624.9,205.55C620.56,207.27 616.37,209.12 612,210.55C611.39,209.55 612,209.04 612.85,208.65C614.56,207.29 616.63,206.42 618.15,204.79C616.69,206.38 614.67,207.2 613.04,208.55C611.62,208.75 611.51,209.82 611.44,210.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.61,185.93C684.27,186.39 685.01,186.16 685.71,186.17C687.86,186.17 690.03,186.17 692.18,186.11C693.33,186.06 693.74,186.44 693.72,187.6C693.67,190.15 693.72,192.71 693.72,195.27C693.72,196.92 693.72,196.96 691.94,196.97C684.507,197.023 677.07,197.06 669.63,197.08C669.47,197.07 669.31,197.07 669.15,197.08C668.33,197.17 668.02,196.8 668.03,195.98C668.03,192.48 667.89,189.03 669.03,185.56C672.03,176.21 674.71,166.76 677.52,157.36L677.91,155.97C678.44,154.1 678.44,154.08 676.59,154.08C674.74,154.08 672.59,154.08 670.59,154.16C669.53,154.16 668.96,154.01 668.99,152.75C669.06,150.04 668.99,147.32 668.99,144.6C668.99,143.67 669.32,143.35 670.25,143.35C677.53,143.35 684.8,143.35 692.08,143.24C693.31,143.24 693.53,143.75 693.52,144.82L693.52,152.97C693.467,154 693.244,155.013 692.86,155.97C689.96,165.18 687.03,174.39 684.15,183.6C683.794,184.325 683.609,185.122 683.61,185.93Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.35,220.35L778.2,212.72C779.2,212.72 779.66,213.46 780.37,213.77C781.673,214.527 783.361,214.145 784.21,212.9C785.076,211.755 785.883,210.566 786.63,209.34C792.877,199.573 799.093,189.793 805.28,180C805.7,179.33 806.15,178.67 806.67,177.87L818.15,185.16C818.208,185.604 818.073,186.052 817.78,186.39C810.4,197.97 803.017,209.55 795.63,221.13C794.95,222.2 794.24,223.27 793.46,224.28C791.418,227.215 787.526,228.271 784.28,226.77C781.659,225.59 779.155,224.167 776.8,222.52C775.72,221.88 774.66,221.18 773.35,220.35Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648.72,199.94C647.72,200.18 647.59,199.58 647.47,198.76C646.71,193.54 645.91,188.34 645.13,183.13C643.43,171.837 641.74,160.547 640.06,149.26C640,148.87 639.94,148.47 639.87,148.08C639.71,147.28 640.06,146.91 640.87,146.79C644.66,146.26 648.46,145.79 652.25,145.14C653.25,144.97 653.64,145.24 653.79,146.28C654.53,151.5 655.34,156.7 656.12,161.91C657.827,173.283 659.53,184.65 661.23,196.01C661.53,198.01 661.56,198.01 659.68,198.33C656,198.89 652.4,199.4 648.72,199.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.2,255.45C714.96,253.67 713.11,252.29 711.38,250.78C710.5,249.838 709.114,249.548 707.93,250.06C705.71,250.87 703.4,251.44 700.84,252.2C701.489,249.847 702.318,247.546 703.32,245.32C703.959,244.123 703.787,242.648 702.89,241.63C701.43,239.78 700.2,237.76 698.65,235.48C701.55,235.63 704,235.7 706.44,235.91C707.55,236.085 708.659,235.554 709.22,234.58C710.63,232.58 712.22,230.69 713.94,228.41C714.63,230.96 715.3,233.05 715.75,235.18C715.91,236.804 717.143,238.131 718.75,238.41C720.89,238.94 722.93,239.84 725.49,240.76C723.23,242.23 721.38,243.54 719.44,244.68C718.11,245.264 717.3,246.644 717.44,248.09C717.52,250.37 717.3,252.68 717.2,255.45Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M779.66,258.26C780.28,260.49 780.92,262.21 781.22,263.98C781.397,265.505 782.574,266.736 784.09,266.98C785.77,267.44 787.4,268.11 789.09,268.7C788.81,269.7 787.86,269.93 787.19,270.42C786.158,271.173 785.086,271.871 783.98,272.51C783.098,272.92 782.572,273.853 782.68,274.82C782.75,276.88 782.68,278.95 782.68,281.02L782.14,281.28C780.99,280.37 779.85,279.45 778.69,278.55C775.41,276 776.79,276.33 772.76,277.44C771.4,277.82 770.04,278.23 768.43,278.7C768.887,276.713 769.557,274.782 770.43,272.94C771.015,271.795 770.827,270.399 769.96,269.45C768.8,267.95 767.78,266.33 766.44,264.39C768.78,264.5 770.72,264.5 772.64,264.7C773.907,264.919 775.185,264.323 775.83,263.21C777,261.64 778.19,260.18 779.66,258.26Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.09,237.45C631.09,237.57 633.17,237.62 635.21,237.81C636.245,237.971 637.278,237.482 637.81,236.58C638.97,234.9 640.26,233.31 641.81,231.35C642.5,233.76 643.15,235.72 643.58,237.72C643.747,238.76 644.547,239.593 645.58,239.8C647.52,240.41 649.42,241.15 651.74,241.97C650.506,242.901 649.209,243.746 647.86,244.5C645.549,245.349 644.214,247.809 644.76,250.21C644.853,251.712 644.853,253.218 644.76,254.72C642.76,253.13 641.15,251.99 639.76,250.64C638.908,249.778 637.597,249.545 636.5,250.06C634.7,250.67 632.85,251.17 630.81,251.77C630.889,250.323 631.333,248.919 632.1,247.69C633.38,245.28 633.26,243.25 631.34,241.23C630.526,240.244 629.803,239.186 629.18,238.07C629,238 629.09,237.78 629.09,237.45Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M859.23,255.05C859.154,255.036 859.076,255.036 859,255.05C858.32,255.21 857.44,255.33 857.43,256.15C857.42,256.97 858.43,256.71 858.92,257.02L859.36,257.34C858.63,257.84 857.56,258.63 857.15,257.9C856.74,257.17 855.84,256.79 855.61,255.73C856.69,255.62 857.38,254.73 858.26,254.22C858.41,254.68 859.21,254.42 859.23,255.05Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613,208.64C613,209.45 612,209.71 612,210.54C612,210.92 611.77,210.97 611.46,210.92C611.23,210.64 610.9,210.7 610.59,210.65C610.28,210.6 609.83,210.32 610.07,210.06C610.544,209.373 610.953,208.643 611.29,207.88C611.81,207.09 612.39,208.24 612.94,208.58L613,208.64Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.08,262.78C862.183,261.934 863.44,261.309 864.78,260.94C864.093,261.943 863.141,262.736 862.03,263.23C861.84,262.81 861.4,262.93 861.08,262.78Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M851,248.35C851.856,247.379 852.938,246.634 854.15,246.18C853.51,247.279 852.619,248.211 851.55,248.9L851,248.35Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M567.82,119.34C567.128,118.625 566.765,117.653 566.82,116.66C567.82,116.91 568.44,117.36 568.32,118.41L567.82,119.34Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.91,118.42L569.6,119.24C568.86,119.39 568.78,119 568.91,118.42Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.1,204.71L885.6,205.23C885.5,205.47 885.7,205.83 885.29,205.93C885.29,205.74 885.21,205.55 885.18,205.36C885.15,205.17 885.13,204.93 885.1,204.71Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,230.87C222.07,231.07 230.58,232.87 238.4,237.36C246.617,241.837 252.283,249.91 253.7,259.16C254.45,263.46 253.96,267.78 253.27,272.04C249.937,292.38 245.993,312.597 241.44,332.69C240.95,334.87 240.37,337.04 239.67,339.16C235.67,351.36 227.09,358.38 214.51,360.25C204.203,361.709 193.694,359.852 184.51,354.95C175.15,350.17 169.45,342.57 167.7,332.12C167.171,328.068 167.309,323.957 168.11,319.95C171.4,299.53 175.4,279.24 179.94,259.06C180.45,256.8 181.05,254.55 181.77,252.36C185.77,240.36 194.11,233.51 206.45,231.3C207.552,231.103 208.663,230.966 209.78,230.89C210.91,230.82 212,230.87 213.15,230.87ZM222.76,259C222.56,262.74 221.5,267.18 220.64,271.64C217.2,289.353 213.73,307.057 210.23,324.75C209.641,328.05 208.846,331.31 207.85,334.51C207.614,335.27 207.316,336.009 206.96,336.72C205.88,338.72 204.29,339.34 201.89,338.78C199.889,338.521 198.439,336.687 198.65,334.68C198.65,330.58 199.53,326.59 200.3,322.6C204.06,303.173 207.86,283.747 211.7,264.32C212.185,261.324 212.986,258.387 214.09,255.56C214.654,253.758 216.334,252.524 218.222,252.524C218.723,252.524 219.219,252.61 219.69,252.78C222.15,253.44 222.87,254.7 222.76,259Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M583.64,378.88C583.7,379.27 583.45,379.47 583.17,379.63C582.74,379.896 582.173,379.796 581.86,379.4C581.35,378.69 580.92,378.02 579.86,377.98C579.54,377.98 579.47,377.41 579.72,377.21C580.233,376.713 580.907,376.415 581.62,376.37C582.22,376.38 583.62,378.28 583.64,378.88Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.91,368.22C571.78,368.51 571.65,368.86 571.27,368.79C570.89,368.72 570.05,369 569.88,368.22C569.78,367.79 569.6,367.22 570.04,366.89C570.48,366.56 570.88,366.97 571.2,367.31C571.52,367.65 571.86,367.76 571.91,368.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.28,362.55L581.22,360.8L583.67,359.18C583.14,360.32 582.79,361.44 582.28,362.55Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.29,349C541.12,346.35 542.02,345.63 544.34,346.26C544.62,346.33 544.77,346.53 544.7,346.73C544.606,346.943 544.429,347.11 544.21,347.19C543.74,347.34 543.39,346.68 542.9,346.93C542.455,347.083 542.069,347.374 541.8,347.76C541.6,348.11 541.46,348.54 541.29,349Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.72,344.81C578.21,344.66 577.72,344.38 577.72,343.87C577.8,343.13 578.72,343.33 579.15,342.93C579.28,342.82 579.74,343.15 579.79,343.5C580,344.34 579.26,344.52 578.72,344.81Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.13,377.79C522.06,378.11 521.89,378.41 521.56,378.41C521.242,378.366 521.002,378.091 521,377.77C521.005,377.448 521.268,377.185 521.59,377.18C522,377.17 522.1,377.45 522.13,377.79Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M569.16,404.65C568.962,404.754 568.75,404.828 568.53,404.87C568.237,404.904 567.941,404.848 567.68,404.71C567.52,404.58 567.74,404.24 567.96,404.24C568.323,404.212 568.687,404.274 569.02,404.42C569.27,404.57 568.78,404.51 569.16,404.65Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M684,345.26C685.06,345.44 686,345.35 685.9,346.46C685.749,347.006 685.196,347.349 684.64,347.24C683.52,346.86 684.52,346 684,345.26Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.87,382.22C654.61,381.7 655.22,381.68 655.73,382.39C655.94,382.68 656.37,382.99 656,383.39C655.63,383.79 655.36,383.39 655.11,383.11C654.86,382.83 654.15,383 653.87,382.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.5,332.88C693.656,332.474 693.846,332.083 694.07,331.71C694.35,331.33 694.68,330.96 695.21,331.34C695.338,331.424 695.431,331.552 695.47,331.7C695.56,332.4 694.95,332.34 694.56,332.5C694.35,332.59 694.14,332.65 693.5,332.88Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.45,399.85C625.99,399.96 625.45,400.02 625.52,399.49C625.6,398.79 626.34,398.64 626.91,398.55C626.927,398.549 626.944,398.548 626.961,398.548C627.345,398.548 627.661,398.864 627.661,399.248C627.661,399.259 627.66,399.269 627.66,399.28C627.58,400.1 626.89,399.83 626.45,399.85Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.32,370.51C628.15,370.95 627.93,371.36 627.32,371.26C626.95,371.19 626.97,370.85 626.95,370.54C626.95,370.07 627.13,369.8 627.59,369.79C627.626,369.784 627.662,369.781 627.698,369.781C628.043,369.781 628.328,370.065 628.328,370.411C628.328,370.444 628.325,370.477 628.32,370.51Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.18,416.78C668.615,416.376 669.215,416.198 669.8,416.3C670.14,416.3 670.21,416.7 670.12,417.03C670.03,417.36 669.95,417.68 669.52,417.48C669.09,417.28 668.64,417 668.18,416.78Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M678.75,335.91C679.206,335.95 679.579,336.298 679.65,336.75C679.674,336.793 679.686,336.841 679.686,336.89C679.686,337.049 679.555,337.18 679.396,337.18C679.37,337.18 679.345,337.177 679.32,337.17C678.853,337.139 678.453,336.819 678.32,336.37C678.24,336.08 678.48,336 678.75,335.91Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.28,396.23C639.16,396.62 638.93,396.88 638.46,396.76C638.262,396.733 638.114,396.563 638.114,396.364C638.114,396.325 638.119,396.287 638.13,396.25C638.236,395.858 638.617,395.601 639.02,395.65C639.26,395.68 639.29,396 639.28,396.23Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672,428.41C671.983,428.739 671.743,429.016 671.42,429.08C671.13,429.14 671.03,428.89 671.05,428.65C671.046,428.323 671.286,428.04 671.61,427.99C671.84,428 672,428.14 672,428.41Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.43,333.06C681.431,333.074 681.432,333.088 681.432,333.101C681.432,333.321 681.252,333.501 681.032,333.501C681.021,333.501 681.011,333.501 681,333.5C680.777,333.512 680.558,333.428 680.4,333.27C680.23,333.05 680.4,332.86 680.66,332.79C680.947,332.68 681.275,332.795 681.43,333.06Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.45,432.22C610.34,432.15 610.11,432.06 610.12,431.99C610.174,431.681 610.413,431.435 610.72,431.37C610.99,431.28 611.15,431.49 611.12,431.75C611.09,432.01 610.8,432.24 610.45,432.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.43,391.26C636.336,391.55 636.041,391.729 635.74,391.68C635.483,391.679 635.272,391.467 635.272,391.21C635.272,391.155 635.281,391.101 635.3,391.05C635.453,390.775 635.803,390.672 636.08,390.82C636.26,390.9 636.55,390.93 636.43,391.26Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,386.41C352.17,380.19 354.21,374.05 356.27,367.93C367.277,335.263 378.277,302.573 389.27,269.86C390.17,267.16 390.18,267.14 393.03,267.7L434.43,275.79C436.29,276.16 436.33,276.19 436.25,278.05C435.723,290.117 435.18,302.18 434.62,314.24C434.24,322.46 433.853,330.683 433.46,338.91C432.68,356.01 431.903,373.103 431.13,390.19C430.99,393.383 430.847,396.577 430.7,399.77C430.7,400.55 430.57,401.33 430.49,402.31C427.29,401.71 424.25,401.16 421.21,400.56C414.07,399.173 406.933,397.773 399.8,396.36C398.04,396.01 398.03,396.01 398.23,394.25C398.93,387.98 399.65,381.71 400.33,375.43C400.53,373.62 400.5,373.61 398.79,373.28L390.79,371.75C389.23,371.45 389.2,371.46 388.73,373.07C387.59,376.98 386.48,380.9 385.35,384.81C384.683,387.11 384.017,389.413 383.35,391.72C383.11,392.58 382.78,393.1 381.69,392.88C371.277,390.793 360.857,388.723 350.43,386.67C350.41,386.66 350.35,386.59 350.08,386.41ZM404,351.68C400.56,351.01 397.29,350.37 394,349.75C393.05,349.58 393.17,349.08 393.39,348.37C394.74,343.95 396.01,339.5 397.39,335.08C400.72,324.34 404.31,313.69 407.95,303.08C408.139,302.478 408.419,301.908 408.78,301.39C407.13,318.08 405.37,334.77 404,351.68Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M762.37,396.52C761.553,396.336 760.87,395.775 760.53,395.01C761.19,394.59 761.85,394.08 762.53,394.6C763.21,395.12 762.54,395.83 762.37,396.52Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M776,466.85C775.362,466.47 774.979,465.772 775,465.03C775,464.56 775.48,464.27 776.07,464.36C776.66,464.45 776.77,464.7 776.64,465.16C776.51,465.62 776.24,466.21 776,466.85Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.4,343.75C759.4,344.09 759.19,344.29 758.96,344.27C758.273,344.209 757.687,343.738 757.48,343.08C757.35,342.63 757.87,342.17 758.36,342.24C759.2,342.37 759.06,343.28 759.4,343.75Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M740.39,430.14C741.39,429.05 741.05,428.03 741.14,426.9C742.76,429 742.76,429 740.39,430.14Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.34,380.2C742.194,379.99 742.064,379.769 741.95,379.54C741.77,379.08 740.95,378.89 741.38,378.21C741.58,377.93 741.87,378.08 742.14,378.32C742.72,378.81 743.57,379.18 742.34,380.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M728.34,427.08C728.305,427.401 728.032,427.647 727.71,427.65C727.23,427.65 727.08,427.23 726.97,426.87C726.86,426.51 727.25,426.4 727.53,426.39C728,426.36 728.2,426.69 728.34,427.08Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.84,438.59C707.15,438.81 707.46,439.04 707.44,439.47C707.441,439.482 707.441,439.493 707.441,439.505C707.441,439.746 707.243,439.945 707.001,439.945C706.943,439.945 706.884,439.933 706.83,439.91C706.4,439.77 706.39,439.33 706.4,438.91C706.41,438.725 706.564,438.578 706.75,438.578C706.78,438.578 706.81,438.582 706.84,438.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M739.67,430.31C739.75,430.69 739.52,430.79 739.32,430.77C739.12,430.75 738.82,430.61 738.8,430.48C738.74,430.18 738.86,429.88 739.28,429.93C739.485,429.944 739.651,430.106 739.67,430.31Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M743.47,370.64C743.468,370.875 743.293,371.076 743.06,371.11C742.6,371.21 742.55,370.84 742.56,370.56C742.568,370.374 742.723,370.225 742.91,370.225C742.954,370.225 742.999,370.233 743.04,370.25C743.25,370.31 743.49,370.34 743.47,370.64Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.78,352.31C476.58,352.532 477.304,352.972 477.87,353.58C476,354.7 476,354.7 475.78,352.31Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.36,387.9C456.135,388.561 455.474,388.979 454.78,388.9C454.471,388.895 454.219,388.64 454.219,388.33C454.219,388.317 454.219,388.303 454.22,388.29C454.34,387.41 455.36,387.75 455.81,387.24C455.88,387.17 456.3,387.52 456.36,387.9Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.42,314.16C472.42,314.52 472.28,314.9 471.83,314.99C471.353,315.096 470.873,314.795 470.76,314.32C470.63,313.77 471.05,313.58 471.62,313.56C472.19,313.54 472.35,313.64 472.42,314.16Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.73,305.18C467.16,304.81 467.65,305.05 468.11,305.02C468.57,304.99 469.19,304.75 469.11,305.53C469.11,305.96 468.53,306.06 468.11,305.88C467.69,305.7 467,305.84 466.73,305.18Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.16,320.23C465.81,319.37 466.52,319.44 466.83,319.23C467.14,319.02 467.62,318.9 467.83,319.33C468.04,319.76 467.57,319.97 467.18,320.06L466.16,320.23Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.89,295.71C484.65,295.6 484.33,295.46 484.42,295.23C484.615,294.717 485.134,294.396 485.68,294.45C485.79,294.45 485.99,294.64 485.98,294.72C485.89,295.35 485.42,295.58 484.89,295.71Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.09,331C486.4,331 486.65,331.13 486.67,331.51C486.69,331.89 486.45,331.87 486.25,331.89C486.05,331.91 485.64,331.89 485.69,331.45C485.705,331.227 485.87,331.041 486.09,331Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.36,449.91C818.19,447.83 818.19,447.83 816.06,448.35C815.842,448.438 815.591,448.368 815.45,448.18C815.17,447.85 815.31,447.63 815.62,447.43C815.887,447.268 816.136,447.077 816.36,446.86C816.99,446.2 817.77,447.34 818.36,446.7C819.1,445.88 817.57,445.76 817.77,444.93C817.97,444.1 818.89,443.08 820.6,442.47C820.88,443.42 819.73,443.67 819.6,444.47L820.93,444.64C820.15,445.64 819.16,446.35 818.93,447.54C818.82,448.15 819.04,448.45 819.68,448.29C820.88,448 820.93,447.98 821.1,448.88C821.221,449.419 821.441,449.932 821.75,450.39C820.39,452.08 819.32,451.4 818.36,449.91Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.36,449.91C819.46,450.43 820.5,451.31 821.79,450.39C822.086,450.551 822.271,450.862 822.271,451.198C822.271,451.438 822.177,451.668 822.01,451.84C821.06,452.603 820.057,453.298 819.01,453.92C818.67,454.13 818.49,453.74 818.24,453.56C817.73,453.19 817.18,452.87 816.66,452.56C816.76,451.36 818.15,451 818.36,449.91Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M802.82,450.92L804.49,452.18C804.274,452.607 804.012,453.009 803.71,453.38C803.11,454.01 802.53,453.88 802.45,453.05C802.39,452.42 801.78,451.69 802.82,450.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.22,402.16C810.852,401.56 811.52,400.999 812.22,400.48C812.35,400.403 812.497,400.363 812.648,400.363C812.974,400.363 813.273,400.554 813.41,400.85C813.69,401.3 813.28,401.51 813.02,401.79C812.38,402.52 811.56,402.41 810.22,402.16Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.14,462.65C838.08,463.26 838.14,463.83 837.43,463.81C836.845,463.799 836.341,463.383 836.22,462.81C836.205,462.759 836.198,462.705 836.198,462.652C836.198,462.339 836.455,462.082 836.768,462.082C836.816,462.082 836.863,462.088 836.91,462.1C837.36,462.19 838.12,461.88 838.14,462.65Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841,368.35C840.73,368.76 840.67,368.97 840.57,368.99C840,369.09 839.72,369.99 838.98,369.57C838.79,369.46 838.63,369.18 838.78,368.98C839.268,368.264 840.208,367.997 841,368.35Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821,354.42C820.8,354.32 820.61,354.29 820.54,354.19C820.47,354.09 820.44,353.84 820.54,353.77C820.822,353.512 821.123,353.274 821.44,353.06C821.67,352.9 821.94,352.58 822.21,352.94C822.308,353.057 822.362,353.205 822.362,353.357C822.362,353.604 822.221,353.831 822,353.94C821.678,354.123 821.344,354.283 821,354.42Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.24,361.59C843.592,361.604 843.873,361.898 843.873,362.249C843.873,362.293 843.869,362.337 843.86,362.38C843.81,362.8 843.6,363.13 843.12,363.02C842.728,362.947 842.443,362.599 842.45,362.2C842.46,361.72 842.81,361.58 843.24,361.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M813.69,419.36C813.69,419.78 813.33,419.75 813.05,419.79C812.77,419.83 812.65,419.63 812.65,419.38C812.65,419.13 812.89,418.85 813.25,418.87C813.61,418.89 813.62,419.12 813.69,419.36Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M817.2,449.6C817.419,449.645 817.563,449.861 817.52,450.08C817.518,450.26 817.37,450.407 817.19,450.407C817.145,450.407 817.101,450.398 817.06,450.38C816.89,450.33 816.56,450.38 816.73,449.99C816.83,449.8 816.9,449.57 817.2,449.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M844.17,370.3C844.08,370.35 843.9,370.48 843.7,370.58C843.5,370.68 843.33,370.45 843.27,370.26C843.21,370.07 843.41,369.85 843.63,369.81C843.85,369.77 844.06,369.82 844.17,370.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M906.22,375.74C906.272,376.533 905.672,377.231 904.88,377.3C904.51,377.37 904.3,377.14 904.23,376.79C904.06,375.96 904.53,375.67 905.23,375.53C905.573,375.416 905.953,375.496 906.22,375.74Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.77,438C884.67,439.12 884.62,439.81 884.55,440.54C883.28,439.34 883.28,439.34 884.77,438Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M908.61,375.78C908.824,375.704 909.064,375.778 909.2,375.96C909.54,376.31 909.79,376.7 909.44,377.17C909.343,377.281 909.197,377.337 909.05,377.32C908.59,377.2 908.59,376.77 908.54,376.4C908.51,376.19 908.33,376 908.61,375.78Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M899.81,396.29C898.81,395.92 898.61,395.53 898.6,395.04C898.63,394.819 898.749,394.62 898.93,394.49C899.17,394.34 899.39,394.49 899.46,394.75C899.59,395.17 899.66,395.6 899.81,396.29Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.45,434.27C889.45,434.72 889.25,435.04 888.77,435.05C888.768,435.05 888.766,435.05 888.764,435.05C888.462,435.05 888.214,434.802 888.214,434.5C888.214,434.473 888.216,434.446 888.22,434.42C888.341,434.136 888.572,433.912 888.86,433.8C889.23,433.64 889.43,433.89 889.45,434.27Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.27,412.55C909.913,412.843 910.379,413.427 910.52,414.12C909.59,413.73 909.59,413.73 909.27,412.55Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.22,425.33C889.17,425.64 889.02,425.86 888.76,425.77C888.393,425.624 888.146,425.274 888.13,424.88C888.13,424.59 888.33,424.49 888.57,424.54C888.932,424.637 889.194,424.956 889.22,425.33Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.41,488C882.29,487.37 882.55,486.59 882.41,486C882.32,485.6 882.27,485.17 882.87,485.21C883.26,485.21 883.72,485.47 883.6,485.91C883.44,486.594 883.376,487.298 883.41,488Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.24,526.7C523.54,526.03 524.34,525.58 524.17,525.07C523.5,524.45 523.28,525.8 522.64,525.46C523.52,523.91 524.15,523.57 525.03,524.14C525.7,524.58 525.64,524.81 524.24,526.7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.25,508.3C536.444,507.791 536.946,507.463 537.49,507.49C537.98,507.49 538.49,507.56 538.49,508.21C538.49,508.86 537.92,508.77 537.49,508.57C537.06,508.37 536.64,508.74 536.25,508.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.14,528.31C498.454,528.315 498.71,528.576 498.71,528.89C498.71,528.897 498.71,528.903 498.71,528.91C498.71,529.217 498.458,529.47 498.15,529.47L498.126,529.471C497.841,529.471 497.606,529.236 497.606,528.951C497.606,528.93 497.608,528.91 497.61,528.89C497.607,528.867 497.605,528.843 497.605,528.819C497.605,528.54 497.835,528.309 498.115,528.309C498.123,528.309 498.132,528.31 498.14,528.31Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.61,598.28C637.38,598.88 636.67,599.68 637.03,600.28C637.22,600.59 637.51,600.97 636.8,601.04C636.45,601.04 636.11,600.94 636.05,600.61C635.741,599.794 635.964,598.867 636.61,598.28Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.21,572.65C811.098,573.204 810.624,573.616 810.06,573.65C809.496,573.684 809.84,573.41 809.86,573.31C809.929,572.753 810.399,572.325 810.96,572.31C811,572.28 811.12,572.51 811.21,572.65Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,483.59L251.34,483.9C254.83,485.27 258.34,486.66 261.83,487.98C262.89,488.38 263.1,488.85 262.71,489.98C261.96,492.08 261.42,494.25 260.71,496.38C260.38,497.38 260.56,497.92 261.63,498.38C264.87,499.73 264.85,499.79 266.44,496.58C267.11,495.22 267.78,493.85 268.44,492.5C269.22,490.99 269.24,490.97 270.73,491.5C273.93,492.73 277.13,493.97 280.31,495.25C282.31,496.06 282.47,496.51 281.42,498.42C275.207,509.673 268.99,520.923 262.77,532.17C260.963,535.45 259.143,538.73 257.31,542.01C256.44,543.57 256.42,543.58 254.8,542.95L239.42,536.95C237.67,536.26 237.64,536.24 238.06,534.39C240.06,525.757 242.04,517.127 244,508.5C245.813,500.647 247.627,492.797 249.44,484.95C249.61,484.39 249.41,483.54 250.5,483.59ZM261.53,508.76C258.538,514.888 255.199,520.841 251.53,526.59C251.97,525.09 252.43,523.59 252.85,522.11C254.1,517.73 255.38,513.37 256.55,508.98C257.28,506.27 257.29,506.88 259.39,507.67C260.18,507.856 260.915,508.23 261.53,508.76Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.59,603.21C594.45,604.29 593.66,604.43 593.1,604.79C592.54,605.15 592.37,604.71 592.21,604.34C592.05,603.97 591.91,603.72 592.42,603.41C593.045,602.936 593.889,602.858 594.59,603.21Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.74,587.22C598.05,586.48 598.31,585.86 598.59,585.22C598.649,585.207 598.71,585.2 598.77,585.2C599.226,585.2 599.6,585.575 599.6,586.03C599.6,586.074 599.597,586.117 599.59,586.16C599.44,587 598.75,587.21 597.74,587.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.23,581.33C597.628,581.297 597.996,581.555 598.1,581.94C598.2,582.25 597.94,582.32 597.73,582.35C597.35,582.35 596.9,582.45 596.73,582.01C596.56,581.57 596.92,581.45 597.23,581.33Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.8,602.36C594.29,602.46 593.66,602.36 593.73,601.84C593.87,600.84 594.28,601.54 594.55,601.84C594.68,602 594.91,602.09 594.8,602.36Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611,596.88C611,597.19 610.81,597.24 610.61,597.3C610.564,597.32 610.515,597.33 610.465,597.33C610.29,597.33 610.139,597.203 610.11,597.03C610.11,596.73 610.2,596.43 610.6,596.46C610.821,596.465 611,596.649 611,596.87C611,596.873 611,596.877 611,596.88Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M765.44,569C764.9,568.91 764.78,568.55 765.01,568.15C765.67,567.285 766.496,566.561 767.44,566.02C767.54,565.94 767.88,566.09 768.07,566.2C768.279,566.325 768.354,566.595 768.24,566.81C767.451,567.708 766.502,568.451 765.44,569Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.16,544.68C558.32,544.79 557.56,545.43 557.08,544.68C556.89,544.39 556.86,543.32 557.68,543.15C558.5,542.98 558.73,543.85 559.16,544.68Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.13,525.66C558.13,526.2 557.77,526.57 557.43,526.55C556.734,526.52 556.158,525.982 556.08,525.29C556.03,524.98 556.25,524.39 556.68,524.43C557.44,524.48 557.7,525.23 558.13,525.66Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.3,562.59C545.161,562.645 545.029,562.719 544.91,562.81C544.63,563.1 544.31,563.37 543.91,563.12C543.51,562.87 543.8,562.56 543.96,562.31C544.12,562.06 544.5,561.5 545.05,561.83C545.37,562.01 545.15,562.39 545.24,562.68L545.3,562.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.44,532.84C564.412,532.956 564.307,533.039 564.187,533.039C564.139,533.039 564.091,533.026 564.05,533L562.59,532.26C563.78,532 563.78,532 564.44,532.84Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.9,534.15C565.79,534.52 565.5,534.57 565.19,534.48C565.031,534.44 564.919,534.295 564.919,534.131C564.919,534.059 564.94,533.989 564.98,533.93C565.126,533.755 565.342,533.653 565.57,533.65C565.766,533.672 565.917,533.84 565.917,534.038C565.917,534.076 565.911,534.114 565.9,534.15Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.7,585.92C691.431,585.875 691.233,585.64 691.233,585.368C691.233,585.321 691.239,585.275 691.25,585.23C691.262,584.97 691.479,584.763 691.739,584.763C691.794,584.763 691.848,584.772 691.9,584.79C692.083,584.913 692.195,585.119 692.2,585.34C692.2,585.63 692.09,586 691.7,585.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.46,550.48C570.46,550.84 571.24,550.8 570.92,551.32C570.8,551.53 570.53,551.66 570.36,551.47C570.05,551.13 570.28,550.79 570.48,550.47L570.46,550.48Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.64,578.82C713.74,578.55 713.29,577.82 712.57,577.33C714.1,576.79 714.2,576.87 714.64,578.82Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718,576C717.848,576.369 717.489,576.614 717.09,576.62C717.073,576.621 717.057,576.621 717.04,576.621C716.574,576.621 716.19,576.238 716.19,575.771C716.19,575.771 716.19,575.77 716.19,575.77C716.19,575.24 716.57,575.14 716.98,575.26C717.39,575.38 717.85,575.44 718,576Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.49,578.94C718.681,579.225 717.774,578.928 717.29,578.22C716.806,577.512 717.43,577.92 717.55,577.86C718.73,577.26 718.72,578.77 719.49,578.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.82,579.93C713.37,579.98 712.66,580.24 712.52,580.06C712.06,579.46 712.4,578.89 712.96,578.46C713.42,578.79 713.38,579.51 713.82,579.93Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718.32,608.39C718.58,608.562 718.827,608.753 719.06,608.96C719.26,609.18 719.52,609.49 719.26,609.76C719,610.03 718.59,609.76 718.35,609.47C718.197,609.326 718.109,609.125 718.109,608.915C718.109,608.72 718.185,608.531 718.32,608.39Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.09,259.46C861.62,258.85 862.09,258.6 862.62,258.95C863.15,259.3 863.75,259.49 863.4,260.14C863.17,260.59 862.59,260.41 862.17,260.14C861.75,259.87 861.55,259.77 861.09,259.46Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.78,264.11C876.69,262.95 876.69,262.95 877.33,264.53C876.462,264.54 875.599,264.397 874.78,264.11Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M871.06,265C871.44,264.22 872.15,263.91 872.84,263.44C872.78,264.57 872.78,264.57 871.06,265Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880,251.62C880.93,252.84 880.44,253.44 880.24,254.42C879.44,253.39 879.88,252.74 880,251.62Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.17,258.94C884,259.34 883.9,259.84 883.35,259.94C883.324,259.946 883.297,259.948 883.27,259.948C883.056,259.948 882.88,259.772 882.88,259.558C882.88,259.556 882.88,259.553 882.88,259.55C882.874,259.057 883.233,258.629 883.72,258.55C884,258.47 884.12,258.66 884.17,258.94Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.06,269.54C871.914,269.893 871.533,270.092 871.16,270.01C870.95,270.01 870.67,269.94 870.79,269.62C870.897,269.23 871.294,268.987 871.69,269.07C871.9,269.09 872.14,269.17 872.06,269.54Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362,76.35C368.5,77.61 374.83,78.52 381,80.12C382.949,80.552 384.83,81.248 386.59,82.19C389.859,83.888 391.827,87.374 391.59,91.05C391.37,94.478 390.889,97.885 390.15,101.24C388.757,108.847 387.327,116.45 385.86,124.05C385.617,125.299 385.283,126.529 384.86,127.73C383.934,130.721 381.235,132.836 378.11,133.02C375.638,133.206 373.153,133.034 370.73,132.51L353.73,129.51C352.18,129.23 352.17,129.17 352.44,127.65C355.433,111.25 358.433,94.847 361.44,78.44C361.63,77.78 361.82,77.18 362,76.35ZM374.13,88C374.71,88.13 375.19,88.19 375.64,88.34C377.34,88.91 377.87,89.56 377.7,91.34C377.53,93.12 377.15,95.13 376.81,97.02C375.543,103.933 374.263,110.843 372.97,117.75C372.774,118.769 372.503,119.771 372.16,120.75C371.54,122.48 370.69,122.94 368.88,122.83C367.88,122.76 367.67,122.39 367.88,121.45C368.66,117.45 369.37,113.45 370.11,109.45C371.363,102.623 372.62,95.79 373.88,88.95C373.9,88.68 374,88.46 374.13,88Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.8,162.09C717.12,164.98 716.74,165.22 714.8,163.91C715.62,163 716.24,161.84 717.8,162.09Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M729.58,151.51C729.563,151.788 729.33,152.008 729.051,152.008C728.993,152.008 728.935,151.999 728.88,151.98C728.649,151.908 728.515,151.663 728.58,151.43C728.623,151.182 728.84,150.999 729.092,150.999C729.153,150.999 729.213,151.009 729.27,151.03C729.43,151.08 729.51,151.38 729.58,151.51Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.14,149.49L409.21,144.63C408.29,144.26 408.21,143.72 408.52,142.94C409.25,140.74 409.91,138.53 410.7,136.35C411.08,135.28 410.8,134.77 409.76,134.35C405.76,132.84 406.76,132.6 405.03,135.94C404.2,137.49 403.39,139.05 402.62,140.63C402.22,141.45 401.77,141.55 400.92,141.19C396.92,139.52 392.97,137.91 388.77,136.19C389.1,135.55 389.36,135.01 389.66,134.5L414.58,91.09C414.78,90.75 415,90.41 415.17,90.09C415.53,89.33 416.02,89.32 416.72,89.65C417.66,90.09 418.64,90.42 419.6,90.82L432.23,96C434.36,96.88 434.38,96.89 433.85,99L424.55,136.63C423.67,140.19 422.793,143.753 421.92,147.32C421.808,148.088 421.542,148.826 421.14,149.49ZM420.07,106.21C419.998,107.618 419.659,108.999 419.07,110.28C417.67,115.007 416.253,119.723 414.82,124.43C414.37,125.92 414.34,125.94 412.91,125.37C411.892,125.103 410.937,124.637 410.1,124C412.41,119.29 415.1,114.77 417.63,110.2C418.279,109.389 418.632,108.379 418.63,107.34C418.47,106.26 419.6,107 420.07,106.21Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.21,198C559.21,198.42 558.93,198.63 558.58,198.79C558.23,198.95 558.23,198.62 558.2,198.44C558.14,198.03 558.26,197.68 558.73,197.59C559,197.49 559.12,197.68 559.21,198Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M778.83,164.67C779.069,164.7 779.251,164.905 779.251,165.146C779.251,165.228 779.23,165.309 779.19,165.38C779.137,165.645 778.902,165.838 778.631,165.838C778.584,165.838 778.536,165.832 778.49,165.82C778.252,165.799 778.073,165.588 778.09,165.35C778.106,164.972 778.421,164.669 778.799,164.669C778.81,164.669 778.82,164.67 778.83,164.67Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M820.9,222.59C820.9,223.03 820.75,223.39 820.28,223.37C819.81,223.35 819.49,222.95 819.43,222.46C819.37,221.97 819.78,221.79 820.15,221.72C820.89,221.56 820.72,222.23 820.9,222.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M813.16,237.36C813.07,237.48 812.96,237.72 812.92,237.71C812.56,237.62 812.57,237.31 812.57,237.02C812.57,236.73 812.73,236.5 812.89,236.57C813.05,236.64 813.22,237 813.16,237.36Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.92,208.58C613.747,207.506 614.798,206.626 616,206C617,205.51 617.07,204.1 618.25,203.79C618.618,203.645 618.979,203.482 619.33,203.3C619.421,203.245 619.524,203.216 619.63,203.216C619.843,203.216 620.039,203.333 620.14,203.52C620.267,203.812 620.185,204.156 619.94,204.36C618.83,205.456 617.554,206.371 616.16,207.07C615.122,207.649 614.053,208.173 612.96,208.64L612.92,208.58Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.21,165.59C676.96,165.21 676.99,165.07 677.15,164.97C677.67,164.62 678.01,163.76 678.86,164.32C678.994,164.394 679.077,164.535 679.077,164.688C679.077,164.774 679.05,164.859 679,164.93C678.574,165.466 677.882,165.72 677.21,165.59Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.29,188.37C689.5,188.46 689.72,188.53 689.67,188.84C689.637,189.11 689.406,189.314 689.134,189.314C689.092,189.314 689.051,189.31 689.01,189.3C688.9,189.3 688.79,188.91 688.81,188.71C688.81,188.71 688.81,188.71 688.81,188.709C688.81,188.512 688.973,188.349 689.17,188.349C689.211,188.349 689.251,188.356 689.29,188.37Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.7,198.22C799.7,198.81 799.37,198.96 798.9,198.89C798.43,198.82 798.26,198.67 798.37,198.3C798.48,197.93 798.82,197.38 799.37,197.49C799.7,197.55 799.69,198 799.7,198.22Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-348,-68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M820.63,449.4L820.54,449.58C820.44,449.48 820.33,449.38 820.24,449.27L820.36,449.14L820.63,449.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.36,555.59C303.49,554.36 296.75,553.59 290.18,551.83C288.941,551.523 287.73,551.111 286.56,550.6C282.238,548.898 279.707,544.326 280.56,539.76C281.05,535.89 281.64,532.02 282.27,528.16C283.35,521.63 284.48,515.1 285.62,508.58C285.841,507.402 286.138,506.24 286.51,505.1C287.77,501.1 290.3,499.22 294.45,499.04C297.649,499.058 300.838,499.393 303.97,500.04C308.54,500.75 313.1,501.56 317.66,502.34C319.32,502.62 319.32,502.62 319.04,504.34C317.81,511.74 316.61,519.15 315.3,526.53C315.11,527.64 315.5,529.15 313.95,529.73C313.76,529.8 313.72,529.93 313.95,530.01C315.28,530.51 314.47,531.52 314.36,532.2C313.18,539.61 311.91,547 310.67,554.4C310.57,554.72 310.49,555 310.36,555.59ZM294.4,540.33C294.92,537.11 295.51,533.4 296.13,529.71C297.057,524.203 298.01,518.7 298.99,513.2C299.143,512.417 299.361,511.648 299.64,510.9C299.918,510.045 300.668,509.424 301.56,509.31C303.56,508.94 303.98,509.4 303.65,511.39C301.943,521.623 300.237,531.853 298.53,542.08C298.17,544.26 297.2,544.66 295.39,543.35C294.51,542.72 294.32,541.82 294.4,540.33Z",
    style: {
      fill: "white"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoMotto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-motto.b2bcec63.svg";
export { ForwardRef as ReactComponent };